// The adidas AI Lab mock pack — the demo's scripted question and its full
// typed-block response (block kinds → pages/Lab/blocks/index.js). Same
// authoring law as mock/lab/starbucks.js: readout first and VERDICT ONLY,
// CMO cultural-capital vocabulary (never engine internals), NAMED moves,
// digit-free modelView, provenance observed / projected / measured. Pure
// data, no imports (scripts/dump-lab-fixture.js evaluates the file).
//
// THE FIRST adidas PACK (2026-10-30, branch adidas-labs, plan
// docs/plans/adidas-sports-culture-lab/PLAN.md). The user: "add one new ai
// lab for adidas and enable adidas so user can log in, I've added code and
// it is 2133 … topic of lab: Which sports are becoming culture before they
// become mainstream?" The server side was already done — on the PROD
// database adidas is enabled with auth_code 2133 — and
// contexts/SessionContext refuses a coded brand with no mock/lab pack, so
// registering this pack in mock/lab/index.js IS the enable step. THREE
// entries, each built deep (the Estée precedent): the FIRST on the `signal`
// starter type reused from the Starbucks Early Signals (the think script in
// mock/lab/stages.js generalised "menu" → "shelf", never forked), item type
// `experience`: the lead move is a ritual the brand hosts, not a product;
// the SECOND (the same day, plan docs/plans/adidas-next-gen-relevance-lab/
// PLAN.md) on the existing `audience` type, appended LAST so the idle Lab's
// chips gain a second chip of a different type and the Weekly card stays the
// signal (one card per pack since 2026-10-26), the new entry landing in the
// Weekly's archive. The name is
// "Adidas" wherever it stands as a brand name beside the others (user call
// 2026-10-30: "adidas should be capitalized here like all others"); the
// slug and the aliases stay lowercase.
//
// SPORTS-CULTURE SIGNAL question (2026-10-30). Basis: the PROD database
// (user call — the dev row is enabled=false with the same code and NO items
// or runs), queried 2026-10-30 by the plan; a same-day re-query at build was
// not permitted in the build session, so every number below is the plan's
// morning read. Serving rule per (brand, as_of): the completed GLOBAL run
// with the latest executed_at; mocked and deprecated items excluded; a
// pulse with actuality 0 and net valence 0 is "not read"; assessments
// (brand codes, community, styling, art direction) excluded from every
// lane count. SERVED RUN as_of 2026-08-24 (executed 2026-10-06): adidas
// CIQ 85.32, raw 85.26, capital K 75.54, rank 2 of 19 in fashion behind
// Nike 85.94; series 57.3 (26 Jan) → 74.5 → 80.9 → 84.4 → 85.5 → 85.32, a
// steep spring climb and flat since June. Item types: content 100 (79),
// collab 100 (89), archive reissue 99.9 (74), event 99.8 (71), merch 96.3
// (27), experience 84.0 (29), capsule 71.6 (15). STRATEGY RECORD (396 real
// items, 13 Jan → 24 Aug): identity signal 146 plays / reception 37.5 /
// valence +31.4; aesthetic innovation 121 / 41.1 / +36.4; fandom 27 / 42.6
// / +35.4; scarcity 24 / 38.7 / +29.5; opacity 16 / 34.3 / +28.4. ON THE
// 100 EVENTS + EXPERIENCES (the lead type): aesthetic 82 / 43.4 / +37.5,
// identity 58 / 43.0 / +34.2, opacity 17 / 45.2 / +40.8, scarcity 17 / 46.7
// / +41.6, fandom 14 / 45.3 / +41.6 — the rarely played strategies are the
// best received on a ritual (the first quadrant: x = plays as a share of
// aesthetic's 82, y = valence as a share of scarcity's 41.6, clamped 97).
// adidas's OWN SPORT LANES since 1 Jan (regex over title + summary):
// football 141 · terrace 62 · running 46 (run clubs 12 on the matrix regex)
// · basketball 26 · tennis 8 · skate 6 · F1 4 · women's sport 4 · trail 4 ·
// padel 2 · golf 1 · surf / pickleball / Hyrox / cycling / climbing 0. Base
// / net valence per read window: F1 — "Original Forever" content 53.2 /
// +87, +40 (the best-received non-football sport play on the record);
// Mercedes-AMG Petronas "Blue Wonder" 36.7 / +73, +26, +47; Audi Revolut F1
// collection 32.9 / +26, +60, +27; Super Bowl brand hub 21.2 / +53, 0.
// Running — Adizero Adios Pro Evo 3 limited capsule 67.6 / +7, 0; the Evo 3
// merch 50.6 / −14, +60; Song for the Mute "Run In Love" 42.3 / unread;
// BAPE × Adizero EVO SL 39.6 / +46, +40, +40, 0; SATISFY Adios Pro 4 38.6 /
// +27, +20; adidas Runners City Night Berlin event 24.1 / +73 (the widest
// grade-to-read gap on the record); Hyperboost × Prince Puckler's Run,
// Eugene 19.3 / +53, +13. Padel — Metalbone Pro EDT 2026 Ale Galán 29.6 /
// unread; World Cup padel racket collection 27.8 / +67. Skate — Thrasher ×
// Argentina 39.1 / +47, +67, +40; Adimatic by Jamal Smith 33.9 / 0, +13;
// Temple of Skate 33.1 / +53; "Parallels" 30.6 / 0. Women's — Tate McRae
// Climacool 33.3 / +67; Sophie Cunningham Crazy Energy PE 36.0 / +33, +13;
// Copper × Ryoko Rain 26.5 / +60, +40; Hibbett launch 25.2 / unread; WNFC
// video 18.3 / +33. Football contrast — Home of Soccer event 48.0 / +73,
// +33. THE BOARD'S SPORT LANES (every enabled brand, real items since 1
// Jan, assessments excluded; matrix cells = count scaled to the column's
// busiest brand, a single play on a two-play column reads fifty — a step,
// not a lead): run clubs max 12 (adidas 12, Lululemon 12, Nike 7, Red Bull
// 1); fitness racing 0 on the WHOLE index; padel max 2 (adidas 2, Lululemon
// 2, Gucci 1, Red Bull 1); motorsport max 22 (Red Bull 22, adidas 4, LV 2,
// Gucci 2, Lululemon 2, Netflix 1; Ferrari's 42 is its own sport and off
// the grid); women's max 4 (adidas 4, Nike 4); skate max 8 (Nike 8, adidas
// 6, Red Bull 3, LV 2); cycling max 7 (Red Bull 7, Tesla 3, LV 1, Netflix
// 1, adidas 0). LANE BANDS (median / p75 of base, board-wide; best other
// brand; best presence received): run clubs 25.3 / 37.6, Red Bull Cyborg
// Season Ultra 600 46.5, received 73; motorsport 32.7 / 38.3, LV F1 Miami
// trophy trunk 48.4 (Apple "Shot on iPhone" 73.7 is a film, left off),
// received 87; padel 28.6 / 29.4, Gucci Padel Invitational Sydney Opera
// House 29.4 (+67), received 67; women's 33.3 / 34.0, Nike A'ja Wilson
// signature ad 50.7, received 80; skate 33.3 / 39.1, UGG Palace × UGG 43.0,
// received 73. PRECEDENTS for `similar` (slugs in config/vocab BRAND_STYLE):
// Red Bull Cyborg Season Ultra 600 46.5; Lululemon SeaWheeze Half Marathon
// 20.7 (+73, +26); Lululemon Trafford Centre padel pop-up 25.8; Gucci Padel
// Invitational 29.4 (+67); LV × Pinarello bike 39.0 (+67, +20); Jacquemus ×
// Nike Moon Shoe 45.4; Nike × Germanier Osaka French Open 56.2.
//
// PUBLIC FACTS (verified 2026-10-30; sources and tiers in the plan). Hyrox:
// Puma official sportswear provider since 2017, renewed 1 Oct 2025 to 2030
// and title partner of the World Championships; 2024/25 season 650,000+
// athletes, 2025/26 1.5M+ over 200+ race days, 2026/27 107 race weekends
// and 2M+ expected (organiser figures, Jul 2026); 650 athletes at the first
// race, Hamburg 2017; majority sold to an L Catterton-led consortium 8 Sep
// 2026; World Triathlon term sheet 28 Oct 2026, "Hybrid Racing" with a
// pathway toward the Olympic programme, Worlds Hong Kong Jun 2027. adidas
// has NO Hyrox deal: the Adizero Dropset Elite, "adidas's first designated
// HYROX shoe", shown at the Primer Feb 2026; its hybrid roster "more than
// tripled"; the 2026 world champion Alyssa McElheny races on an adidas
// deal; adidas backs the rival ATHX Games circuit (14 European events in
// 2026). Running: Strava Year in Sport 2025 — new clubs nearly quadrupled
// to 1M, running clubs ×3.5, 39% of Gen Z exercise to meet people, 1 in 5
// Gen Z had a date through a run club, Gen Z race logging +28% to +39%, 64%
// would rather spend on gear than a date; London Marathon 2026 ballot
// 1,133,813 (+36%), 2027 ballot 1,338,544; Nike After Dark Tour 2025
// 50,000+ women across 7 races; Adizero Adios Pro Evo 3 $500 won London
// 2026 in 1:59:30; Song for the Mute × EVO SL launched with A.P. Run Club,
// Sydney, Aug 2026. Padel: Playtomic / Strategy& 2026 — 58,300 courts,
// ~20,000 clubs, 19.4M players, 7,900 courts built in 2025, 91,000
// projected by 2028; Britain 15,000 players (2019) → 1.5M (Oct 2026); US
// 1.07M players on ~1,000 courts (SFIA 2026); Sweden peak-hour occupancy
// 52% → 21%, Chile 80 clubs closed; Nike rackets shown Jul 2026, entry
// reportedly 2027; Gucci Padel Invitational Sydney 15–16 Aug 2026; Reserve
// Padel members' clubs; adidas Padel is a LICENSEE business (All for
// Padel), no court, club or city programme. Pickleball: SFIA 24.3M US
// players 2025, +53% → +46% → +23% → +1.3% in H1 2026; The Picklr Chapter
// 11 ~9 Oct 2026; net indoor court additions 418 (Jun) → 70 (Sep 2026);
// adidas paddles licensed. F1: 827M fans (+12%), 43% under 35, 48% of new
// fans women, "Formula 1 aesthetic outfit" searches +483%; adidas ×
// Mercedes-AMG Petronas Feb 2025, adidas × Audi Revolut Feb 2026. Women's
// sport: Deloitte ≥$3bn revenue 2026 (+25%, +340% vs 2022), basketball and
// football 35% each; WNBA 2026 3.8M attendance, 90M+ viewers; Cunningham PE
// sold out in under an hour. Climbing: adidas Samba Climbing Shoe on a Five
// Ten outsole, 6 Oct 2026; climbing gyms 53 new vs 60, "boom times are
// over". adidas Q3 2026: revenue €7.25bn +9%, operating profit €1.01bn
// +37%, Running and Training footwear double-digit in own channels, Gulden:
// "Running has become one of our biggest engines." REJECTED, never in
// copy: "adidas Golf was sold" (false); any Puma Hyrox revenue line; Hyrox
// "fastest-growing sport" slogans and women-share figures; hashtag counts;
// the 2024 Strava "+59%"; the 2020 Gen Z poll; "RUN02" as a campaign name.
// GOOGLE TRENDS: one comparative worldwide SerpApi call 2026-10-30, "padel,
// hyrox, run club, pickleball, bouldering", monthly means Jan 2024 → Sep
// 2026 (the Dec 2023 and part-month Oct 2026 points dropped), busiest month
// of any term = 100 — the raw fetch is docs/plans/adidas-sports-culture-lab
// /trends-2026-10-30.json. First- vs last-twelve-month means: padel 55.5 →
// 92.8 (×1.7), hyrox 7.9 → 49.9 (×6.3), run club 3.3 → 7.8 (×2.4),
// pickleball 39.8 → 64.2 (×1.6), bouldering 4.5 → 5.2 (flat, the ghost).
// The September 2026 hyrox spike (87) is NOT the season opener — the
// 2026/27 season opened in July (Delhi) and August (Cape Town); September
// holds Washington DC, Maastricht and Oslo — so the highlight is labelled
// "September's spike", the plan's fallback. PROJECTED: the prices — +0.9 /
// +0.7 / +0.6 = +2.2, 85.32 → ~87.5, past Nike's 85.94; the cohorts and the
// second quadrant are an author's read of the dated facts above.
//
// NEXT-GEN RELEVANCE question (2026-10-30, entry `next-gen-relevance`, type
// `audience`, item type `experience` — the lead move is a room, not a shoe).
// Basis: the plan's 2026-10-30 PROD read (the skill script with the next-gen
// regex and lead type experience since 1 Jan 2026, plus the nine queries in
// docs/plans/adidas-next-gen-relevance-lab/prod-queries.sql); the build
// session's same-day re-query was not permitted, so every measured number
// below is that morning read, served run as_of 2026-08-24 (executed
// 2026-10-06): adidas 85.32 / raw 85.26 / K 75.54, #2 of 19 in fashion
// behind Nike 85.94, FLAT since June, every lifestyle type at its ceiling
// since April (collab 100 from 20 Apr, archive 98–100 all year, content 100
// from Feb) while the month's reception cooled from 42.3 (Feb) to 32.5
// (Jul) on a steady 40–60 plays a month. THE EVENTS + EXPERIENCES CUT (100
// plays): aesthetic 82 / 43.4 / +37.5, identity 58 / 43.0 / +34.2, scarcity
// 17 / 46.7 / +41.6, fandom 14 / 45.3 / +41.6, opacity 17 / 45.2 / +40.8 —
// the collab shelf (89) is read ~8 under it. NEXT-GEN LANES since 1 Jan
// (n / avg valence / best presence): originals 78 / +35 / 93, superstar 28
// / +33 / 93, samba 14 / +44 / 87, yamal 6 / +44 / 93, jennie 3 / +58 / 93,
// teen-youth-campus 7 / +7.5 / 60 (Brawl Stars 0, Campus × Cali DeWitt 0,
// Tennessee film 0, the youth tournament and the Little League party
// unread), women-girls 7 / +13, gaming-virtual 4 / +17, gen z 0, gen alpha
// 0 (no play names a generation; no adidas-owned world on the record — the
// Dec 2025 Roblox festival was FIFA's game, before the window). THE YOUTH
// PLAYS' READS (base / net valence per window): "Hotel Superstar" film 35.1
// / 93, 60; Messi "El Último Tango" 34.3 / 87, 67, 33; Toy Story × adidas
// 36.3 / 80, 80, 53, 47 (the best-read character play on the whole fashion
// board this year); Runners City Night Berlin 24.1 / 73; Jennie teaser 45.5
// / 67, 67; Care Bears × adidas 32.7 / 0, 53, 67; Home of Soccer hubs 37.0
// / 67, 60, 46, 0 (the North American event 41.0 / 67); Tate McRae
// Climacool 29.7 / 67, 53; Lamine Yamal F50 campaign 44.2 / 13, 0, 60, 27,
// 47; Stan Smith bring-back 30.4 / 40, 6, −27, 53; Bad Bunny ballerina 42.6
// / −7 (his exhibition, apparel and tour merch 53–73); Brawl Stars × adidas
// 36.1 / 0; Originals Sport launch content 31.7 / 0 (campaign 28.2 / 40);
// Adizero Adios Pro Evo 3 limited 67.6 / 7, 0. LANE BANDS (fashion board,
// real plays since 1 Jan: median / p75 of base; received): football 32.6 /
// 39.0 / 93, running 29.0 / 36.7 / 80, basketball 34.3 / 38.3 / 80, skate
// 33.3 / 41.0 / 87, character-family 35.7 / 37.0 / 80, gaming 30.5 / 34.4 /
// 73, women's sport 30.3 / 34.0 / 67. The board's youth-named lane: Nike 8
// plays / +38 (its own tournaments), adidas 7 / +7.5 (a licence). PRECEDENTS
// for `similar` (slugs in config/vocab): Lululemon SeaWheeze 20.7 (+73,
// +26); Nike A'ja Wilson signature ad 50.7; Nike × One Piece tease 47.0
// (+60); Uniqlo Retro Pokémon Returns 34.0 (+60); Nike × Germanier Osaka
// French Open 56.2; Gap × Malbon 35.4 (+67, +60); Jacquemus × Nike × FFF
// 51.3 (+73, +60, 0). New Balance, On, Salomon and Puma are MEASURED rows
// on the chart and in the copy by user call (2026-10-30), provenance here
// and in the plan only — none has a vocab slug, so none sits in `similar`.
//
// PUBLIC FACTS (verified 2026-10-30; sources and tiers in the plan). The
// teen survey (fall 2026, 8,934 US teens aged 13–19, fieldwork 10 Aug – 21
// Sep, read on trade coverage, the primary 403): favourite footwear brand
// Nike 45%, adidas 10%, New Balance 7%, Birkenstock 5%, UGG 4%, Converse 4%,
// On 3%, Asics 2%; the adidas all-teen series fall '23 → '26 = 7 → 9 → 11 →
// 10 (the circulating "14% → 10%" is the GIRLS' fall '26 figure mis-read as
// an all-teen fall '25 one — never in copy); girls Nike 31 / adidas 14
// (flat y/y, 3 in 2023) / UGG 10 / Birkenstock 8 (+3) / NB 7 / Converse 6 /
// On 3 / Asics 1; boys Nike 56 / adidas 8 (−1) / NB 8 / On 3 (#4, #10 two
// years ago) / Asics 3 (#5) / Birkenstock 3 / Converse 1; upper-income
// athletic On 9% (#2) vs adidas 8%; upper-income girls' athletic Hoka 13 /
// On 12 / NB 9 / adidas 4; apparel adidas 2% (#9, PacSun ahead among boys);
// athletic brands 29% of teen fashion mindshare (32 last year, 44 three
// years ago); teen footwear spend −1% after −6%, apparel +7%. adidas Q3
// 2026 (29 Oct): revenue €7.25bn +9%, footwear €3.83bn flat, apparel
// €2.90bn +19%, Performance +14%, Lifestyle +3%, "the first Originals Sport
// collection for her … recorded exceptional sell-out rates"; Gulden on
// lifestyle footwear: "the white elephant in the room", "at the back end of
// 2027 we will be in a different situation"; Q2: "especially for him … pretty
// heavily discounted", running "growing almost 30%", basketball the one
// negative (−20% Q1, −21% Q2); Annual Report 2025: "With the Samba, the
// Gazelle, and the Spezial, we really brought the brand back to the young
// female consumer"; Evo SL "approaching 10 million pairs" in its first year.
// Nike Q1 FY27 (1 Oct): running up double digits, Jordan down mid-teens,
// "oversupplying our iconic retro product", "a lack of energy in the
// lifestyle space". New Balance 2025 $9.2bn +19%. On Q2 2026: "consumers
// under 34 now make up over one-third of the customer base", the Cloudtilt
// their shoe (Q3 due Nov 2026 — re-check). Salomon Q2 2026 +37%, XT-6
// "resonating with a younger and more diverse audience" (Q3 due 17 Nov).
// Puma Q3 2026 −6.3%, its sixth quarter of decline, the Speedcat below
// retail on resale. Circana H1 2026: US running footwear +13% in dollars
// and units, sport-lifestyle declined, adidas running +28% in Q2. Roblox Q3
// 2026: 138M DAUs, 34% under 13, 37% aged 13–17; Vans World 132M+ visits,
// 53–55% of play under 13; the adidas Football Festival inside FIFA Super
// Soccer (Dec 2025, "Gen Z & Alpha"): 51.5M visits in four weeks, no
// persistent adidas world. Nielsen Oct 2026: 75.2M American soccer fans in
// July 2026 vs 66.8M a year earlier; YouGov Gen Z buzz for the tournament
// 43 vs 25 in 2022. Beano Brain 2025 (UK, 12,000 kids aged 7–14): adidas
// #14, up fifteen places. ESPN WNBA 2026: persons 2–17 +29%. FDRA / CPI:
// US retail footwear +5.2% y/y in May 2026, children's +2.3%. Counters
// (30 Oct 2026, DolphinRadar): @adidasoriginals 33.65M (−8K in four weeks),
// @adidas 29.84M (+112K), @newbalance 9.40M (+60K), @nike 290.87M (−189K).
// REJECTED, never in copy: "14% to 10%"; any Samba / Gazelle / Spezial unit
// or revenue figure ("35 million Sambas" is a 2016–18 lifetime count); the
// Terrace share of revenue (a 2024 estimate); adiClub 303M (2022); NIKELAND
// 21M (2022); the Razorfish Gen Alpha rank (2024); Omnisend Shein 73%
// (2024); "Hyrox is Gen Z" (average age 36); "On is the fastest-growing
// brand with teens"; AE 1 "highest-selling signature line"; hashtag view
// counts as a measurement; report-seller market sizes; "adidas targets Gen
// Z" for any 2026 lifestyle launch (adidas frames none that way).
// GOOGLE TRENDS: one comparative worldwide SerpApi call 2026-10-30, "adidas
// samba, new balance 530, salomon xt-6, asics gel-kayano 14, puma speedcat",
// monthly means Jan 2024 → Sep 2026 (Dec 2023 and the part-month Oct 2026
// dropped), busiest month of any term = 100 — the raw fetch is
// docs/plans/adidas-next-gen-relevance-lab/trends-products-2026-10-30.json.
// First- vs last-twelve-month means: samba 77.9 → 62.3 (×0.8, peak Apr 2024
// = 100, then Mar 2025 83, Apr 2026 81, Oct 2026 51), new balance 530 27.2
// → 33.0 (×1.2), puma speedcat 1.7 → 20.2 (×11.9, sliding since July),
// salomon xt-6 1.1 → 4.1 (×3.7), gel-kayano 14 1.0 → 1.8 (the ghost).
// EVERY term peaks in April 2026, a platform-wide step, so the highlight is
// the Samba's winter floor (Jan–Feb 2026, 50 and 50), never April. The
// brand-level fetch (trends-brands-2026-10-30.json: adidas ×1.2 and
// growing on the World Cup year, three to four times New Balance) is
// corroboration only — the brand is not losing search, its youth franchise
// is. PROJECTED: the prices — +0.9 / +0.8 / +0.6 = +2.3, 85.32 → ~87.6,
// past Nike's 85.94; the matrix, the lane quadrant and the cohorts are an
// author's read of the dated facts above.
//
// COMMUNITIES question (2026-11-02, entry `communities-next`, type
// `community` reused — the think script's third stage generalised from
// "your club and café record" — item type `community`, appended LAST so
// the chips read signal · audience · community; plan
// docs/plans/adidas-communities-lab/PLAN.md). Basis: the plan's 2026-11-02
// PROD read (the skill script with the community regex, plus the seven
// queries in docs/plans/adidas-communities-lab/prod-queries.sql, after the
// user allowed prod reads); the build session's same-day re-query was
// blocked by the classifier, so every measured number is that morning
// read, served run unchanged (as_of 2026-08-24, executed 2026-10-06: 85.32
// / raw 85.26 / K 75.54, #2 of 19 behind Nike 85.94). THE COMMUNITY
// ASSESSMENTS (query 5): 26 Jan 74.5 (terrace culture, hip-hop,
// streetwear, adiClub, the Confirmed app), 4 May 75.3 (adiClub, Adidas
// Runners, terrace fashion, sneaker collecting), 10 Aug 78.2 (adiClub,
// Confirmed, UK casuals, global sneakerheads, Samba / Gazelle / Spezial) —
// the matrix lights a crowd the text names. COMMUNITY LANES since 1 Jan
// (query 1; n / avg base / avg net valence / best presence / read):
// supporters 34 / 29.9 / +21.9 / 87 / 22; Latin & Chicano 28 / 38.2 /
// +32.1 / 87 / 24; sneakerheads 22 / 36.7 / +25.9 / 87 / 18; club & music
// 14 / 30.1 / +38.5 / 73 / 8; dance & ballet 9 / 29.7 / +36.3 / 80 / 4;
// k-pop & Asian 8 / 34.3 / +50.7 / 93 / 5; women's sport 7 / 26.9 / +59.0
// / 67 / 3; skate 7 / 33.4 / +26.8 / 67 / 7; queer & pride 0. LANE BANDS
// (query 4, board median / p75 of base, received): supporters 29.7 / 35.2
// / 87; k-pop 35.0 / 39.9 / 93; dance 25.0 / 35.1 / 80; Latin 38.3 / 42.7
// / 87; skate 33.4 / 39.7 / 87; women's 31.8 / 35.0 / 67; Black diaspora
// 41.8 / 44.7 / 60; pride 22.3 / 26.5 / 67 (the Bob Marley Samba, 41.9 /
// 87, sat outside the band's regex and is left off the lane). THE BOARD PER
// LANE (query 3, n / avg valence): Latin — Zara 8 / +53.2, UGG 6 / +65.9,
// Nike 5 / +45.5; k-pop — Gucci 6 / +63.3, Nike 5 / +5.5, Lululemon 3
// unread; women's — Nike 4 / +28.1 only; dance — Lululemon 26 / +9.7, Nike
// 2 / +16.5; supporters — Nike 16 / +30.8, Lululemon 8 / +13.6; skate —
// Nike 8 / +43.4. STRATEGY RECORD ON THE COMMUNITY PLAYS (query 6, plays /
// reception / valence): identity 50 / 38.8 / +33.3, aesthetic 41 / 40.3 /
// +34.7, fandom 10 / 46.7 / +37.0, scarcity 4 / 41.7 / +41.7, opacity 3 /
// 33.3 / +33.3 (the quadrant: x = plays as a share of identity's 50,
// clamped 97; y = 50 + 5 × (reception − 40.1), the community plays'
// weighted average reception reading fifty). THE PLAYS (query 2,
// base / best presence / net valence per window): Someone Somewhere Mexico
// 44.7 / 80 (80, 0, 0, 33); Mexico women artisans kit 44.3 / 67 (0, 60,
// 0); Chavarria Love Prevails 49.7 / 67; BadBo 1.0 debut 47.6 / 73 (73,
// 40, 40, 47, 34, 0); red ballerina 42.6 / 20 (−7); Chavarria × Compton
// Cowboys 38.3 / 0 (0); Taekwondo Mei Ballet Flat 38.3 / 80 (27, 60, −20,
// −7, 27, 47, 60, 73); JENNIE teaser 45.5 / 67; Ado Japan jersey 41.0 / 0
// (−27); Football Culture collection 27.0 / 87 (87, 47, 40, 0). PRECEDENTS
// for `similar` (query 7, vocab slugs): UGG × Willy Chavarria debut 39.3
// (80) and UGG & KISSES 47.8 (73); Uniqlo UT × ZO&FRIENDS 33.3; Dior ×
// Jimin ARIRANG 34.2; Chanel × Karina Vogue Korea 26.0; Nike Dance of
// Champions 27.7; Lululemon SeaWheeze 20.7; Nike × Jorge Campos 31.6; City
// Jeans Puerto Rico Nike Shox 20.0. New Balance, On, Salomon and Puma are
// MEASURED rows in the "who holds" matrix by user call (2026-11-02),
// authored from the public facts below; no vocab slug, never `similar`.
//
// PUBLIC FACTS (verified 2026-11-02; tiers and URLs in the plan). adidas:
// Q1 2026 Latin America +26%, Japan / Korea +23%; Q2 Latin America +28%,
// Japan / Korea +18%, Gulden "LATAM on fire, especially in Mexico"; Q3
// (29 Oct) Greater China +13%, Gulden "Original footwear is currently
// negative", Originals apparel "growing almost at 50%", "Terrace is still
// very strong", the Jennie collaboration "coming out of Japan with a square
// toe, is now flying"; World Cup: four times the 2022 jerseys, Mexico the
// best seller ahead of Argentina (to Bloomberg, 20 Jul); Lyst Q1-26 #3 the
// Chinese-style track top, Q2-26 #9 the Chavarria jersey; Bad Bunny's
// halftime suit was Zara; adidas × Unrivaled from the 2027 season (Sep
// 2026); the Oaxaca slip-on withdrawn, apology before Yalálag's assembly
// 21 Aug 2025, reparation terms undisclosed a year on (Proceso, Aug 2026);
// Grace Wales Bonner named Hermès menswear director, debut Jan 2027. Crowds:
// Harris Gen Z Weekend Report (Jul 2026, 603 Gen Z aged 18–29) 51% weekend
// loneliness, 37 points above boomers, 65% closer in wellness settings than
// nightlife; Deloitte (Apr 2026) women's elite sport ≥ $3bn in 2026, +25%;
// SFIA mid-year (12 months to Jun 2026) Pilates +10.9%, running +1.0%; Pew
// (Mar 2026, 3,507 adults) 42% of Hispanic adults likely to follow the
// World Cup vs 28% of all; Piper Sandler fall 2026 girls adidas 14% / boys
// 8%, upper-income girls On 12% vs adidas 4%. Rivals: UGG × Chavarria
// debut 27 Aug 2026; New Balance 2025 $9.2bn +19%, Grey Days with
// McLaughlin-Levrone; On FY25 APAC +96%, Q2 2026 APAC +43.1%, Zendaya
// co-designed the Cloudzone Moon; Salomon China core consumers under 100K →
// ~10M in five years, Sportstyle aimed at young women with no figures;
// Puma Q3 2026 APAC +10.0%, North America −17.2%, the Speedcat its 2025
// lifestyle driver; Lululemon Q2 FY26 Americas comps −12%; Nike After Dark
// Tour 50,000+ women. COUNTERS: hashtagradar's cached TikTok counts read
// 2026-11-02 (#balletcore 32.8K posts / ~1B views, #blokecore 19.2K /
// 481.3M) — relative scale only, the cache undated. REJECTED, never in
// copy: Gulden's "terrace growth wasn't sustainable" (paywalled, snippet
// only); "no need for the next Samba" (a headline, no verbatim quote); any
// Taekwondo or balletcore sales figure (none published; END. lists pairs at
// 40–60% off, a softening tell, not data); Strava's "39% of Gen Z exercise
// to meet people" (conflicting bases); the 2023 Hallyu fan count (stale);
// Hyrox demographics; report-seller resale market sizes; the Bad Bunny
// "sold out" claim; a current global adidas CMO (none found).
// GOOGLE TRENDS: one comparative worldwide SerpApi call 2026-11-02,
// "blokecore, willy chavarria, jennie adidas, adidas taekwondo, balletcore",
// monthly means Jan 2024 → Oct 2026 (Dec 2023 dropped), busiest month of
// any term = 100 — the raw fetch is docs/plans/adidas-communities-lab/
// trends-2026-11-02.json. First- vs last-twelve-month means: adidas
// taekwondo 12.5 → 67.1 (×5.4, peak May 2026 = 100, Oct 44), willy
// chavarria 5.7 → 30.8 (×5.4, peak Mar 2026 52), jennie adidas 2.3 → 16.4
// (×7, 65 in Aug and Sep 2026, the collection's months, 24 in Oct),
// blokecore 4.9 → 5.1 (flat), balletcore 3.6 → 6.1 (the ghost). A first
// fetch with "bad bunny adidas" read that term many times the others and
// flattened the chart; it was dropped, not swapped silently. PROJECTED:
// the prices — +1.0 / +0.8 / +0.6 = +2.4, 85.32 → ~87.7, past Nike's
// 85.94; the "who holds" matrix and the cohorts are an author's read of
// the dated facts above.

export const ADIDAS_LAB = {
  brand: "adidas",
  name: "Adidas",
  // the demo persona greeted on the Lab — this Alex is adidas's own
  person: "Alex",
  // THE WEEKLY PERSPECTIVE's one card (pages/Leaderboard/WeeklyOne): the
  // sports-culture signal under the entry's own words and type, measured
  // on this pack's own day (every pack's day differs — ugg 10-09, tiffany
  // 10-14, estee 10-16, starbucks 10-19). The preview is the answer's own
  // numbers: the trend is the hyrox search line, every other month from
  // January 2025 to September 2026 (×6 on the two-year means); the ring
  // the share of Formula 1's new fans who are women; the bars the second
  // quadrant's momentum read for the three lanes the moves price.
  weekly: {
    sources: 2061774,
    cards: [
      {
        entry: "sports-culture-signal",
        measured: "2026-10-29",
        preview: {
          trend: {
            value: "×6",
            label: "Fitness racing search",
            series: [19, 26, 28, 21, 31, 42, 41, 50, 54, 41, 87],
          },
          ring: { value: 48, label: "F1's new fans, women" },
          bars: {
            title: "Culture ahead of size",
            rows: [
              { label: "Fitness racing", value: 88 },
              { label: "Run clubs", value: 76 },
              { label: "Padel, the US", value: 64 },
            ],
          },
        },
      },
    ],
  },
  entries: [
    {
      id: "sports-culture-signal",
      // the lead move is a ritual the brand hosts, not a product
      itemType: "experience",
      type: "signal",
      question: "Which sports are becoming culture before they go mainstream?",
      aliases: [
        "which sports are becoming culture before they become mainstream",
        "which sports are culture before they are mainstream",
        "which sports are becoming culture",
        "which small sports should adidas own before nike does",
        "which sports should we own early",
        "what sport is the next culture",
        "is hyrox becoming culture",
        "is fitness racing a real signal",
        "is padel a real signal",
        "sports becoming culture",
        "emerging sports",
      ],
      askedOn: "2026-10-30",
      blocks: [
        {
          kind: "readout",
          provenance: "observed",
          verdict:
            "Two. Fitness racing and running as a night out are becoming culture ahead of their size, and both are open at your scale. Padel is already culture and is going mainstream in Europe, so its window is the US. Pickleball went mainstream without ever becoming culture, and Formula 1 you are already in.",
        },
        {
          kind: "stats",
          provenance: "observed",
          insight:
            "The sports to watch are the ones where the crowd and the feed are growing at the same time. Fitness racing doubled twice and still has no owner of its culture. Run clubs tripled on the one app that counts them. Padel is the largest curve and the most built, which is the sign that its early window has moved to the one market still short of courts. Pickleball shows what mainstream without culture looks like, a plateau.",
          items: [
            {
              label: "Fitness racers, last season",
              value: "1.5M",
              hint: "athletes across the last fitness racing season, up from 650,000 the season before and 650 at the first race nine years ago; two million are expected this season",
            },
            {
              label: "Run clubs on Strava",
              value: "×3.5",
              hint: "how much the running clubs on the app multiplied in the year to last September, inside a million clubs of every kind; new clubs nearly quadrupled",
            },
            {
              label: "Padel players, worldwide",
              value: "19.4M",
              hint: "active players on 58,300 courts last year, with 7,900 courts built in that one year; the US has a million players on about a thousand courts",
            },
            {
              label: "Pickleball, this half-year",
              value: "+1.3%",
              hint: "the growth in US players in the first half of this year, after three years at +53%, +46% and +23%; the sport that went mainstream first is the one that stopped",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The signal is not size. Pickleball has more players in one country than padel has in the world, and it is the one lane whose operators are going under. The sports becoming culture are the ones people queue for, dress for and meet in. A race with a ballot, a run with a date in it, a court that is a night out. Formula 1 shows where that road ends, a sport whose new fans are mostly young women and whose paddock is a fashion week.",
          title: "What the crowd is doing",
          provenance: "observed",
          note: "Seven public numbers from the past year. Each line says what the figure counts and why it is here; the last one is the risk, not a signal.",
          rows: [
            {
              label: "Fitness racing's next season",
              context:
                "Athletes the organiser expects across 107 race weekends on six continents this season, after 1.5 million last season. The sport signed a pathway toward the Olympic programme this week and sold its majority to a luxury group's fund in September.",
              value: "2M+",
            },
            {
              label: "The London ballot",
              context:
                "Applicants for this year's London Marathon, a world record and a third more than the year before; the next ballot drew 1.34 million. A race is now something people queue for, not only something they finish.",
              value: "1.13M",
            },
            {
              label: "Gen Z runs to meet people",
              context:
                "Share of Gen Z on Strava who say they exercise to meet people with shared interests; one in five had a date with someone they met through a run club. The run is the room.",
              value: "39%",
            },
            {
              label: "Padel courts built in a year",
              context:
                "Courts added worldwide last year, about twenty-two a day, with 91,000 projected by 2028. Britain went from 15,000 players seven years ago to a million and a half this month.",
              value: "7,900",
            },
            {
              label: "F1's new fans are women",
              context:
                "Share of the fans Formula 1 added last year who are women; 43% of all 827 million fans are under thirty-five. The paddock you doubled into this year has the youngest crowd it has ever had.",
              value: "48%",
            },
            {
              label: "Women's sport revenue",
              context:
                "What women's elite sport earns this year, up a quarter in a year and more than four times 2022; basketball and football are a third each. The WNBA drew 3.8 million people this season and your player edition sold out in an hour.",
              value: "$3bn",
            },
            {
              label: "Pickleball courts added",
              context:
                "Net indoor courts added across the US in September, down from 418 in June, the month before the largest franchisor filed for bankruptcy. Twenty-four million players did not make a culture, and the courts outran them.",
              value: "70",
            },
          ],
        },
        {
          kind: "trendCompare",
          insight:
            "Fitness racing is searched six times as often as two years ago and is still a quarter of padel. That is the shape of a sport becoming culture, a small line turning steep. Padel is the big line and still climbing, which says mainstream, not early. Pickleball grew more slowly than any of them, and bouldering, the sport the feed loves most, did not move on search at all.",
          title: "Attention, five sports",
          provenance: "observed",
          note: "Worldwide Google search interest for the five words, monthly means from January 2024 to September 2026 on one scale. The busiest month of any of them reads 100. Padel is the big curve; hyrox the steep one; run club the small line that more than doubled; pickleball the mainstream one; bouldering the sport the feed loves that search does not confirm. October is left off as a part month.",
          highlight: {
            from: "2026-09-01",
            to: "2026-09-30",
            label: "September's spike",
          },
          series: [
            {
              key: "padel",
              label: "padel",
              color: "#FB923C",
              points: [
                { d: "2024-01-01", v: 46 },
                { d: "2024-02-01", v: 51 },
                { d: "2024-03-01", v: 55 },
                { d: "2024-04-01", v: 57 },
                { d: "2024-05-01", v: 60 },
                { d: "2024-06-01", v: 58 },
                { d: "2024-07-01", v: 56 },
                { d: "2024-08-01", v: 55 },
                { d: "2024-09-01", v: 64 },
                { d: "2024-10-01", v: 64 },
                { d: "2024-11-01", v: 60 },
                { d: "2024-12-01", v: 58 },
                { d: "2025-01-01", v: 59 },
                { d: "2025-02-01", v: 62 },
                { d: "2025-03-01", v: 68 },
                { d: "2025-04-01", v: 65 },
                { d: "2025-05-01", v: 69 },
                { d: "2025-06-01", v: 79 },
                { d: "2025-07-01", v: 87 },
                { d: "2025-08-01", v: 96 },
                { d: "2025-09-01", v: 99 },
                { d: "2025-10-01", v: 95 },
                { d: "2025-11-01", v: 93 },
                { d: "2025-12-01", v: 84 },
                { d: "2026-01-01", v: 88 },
                { d: "2026-02-01", v: 89 },
                { d: "2026-03-01", v: 97 },
                { d: "2026-04-01", v: 100 },
                { d: "2026-05-01", v: 99 },
                { d: "2026-06-01", v: 94 },
                { d: "2026-07-01", v: 88 },
                { d: "2026-08-01", v: 97 },
                { d: "2026-09-01", v: 98 },
              ],
            },
            {
              key: "hyrox",
              label: "hyrox",
              color: "#22D3EE",
              points: [
                { d: "2024-01-01", v: 5 },
                { d: "2024-02-01", v: 6 },
                { d: "2024-03-01", v: 6 },
                { d: "2024-04-01", v: 8 },
                { d: "2024-05-01", v: 6 },
                { d: "2024-06-01", v: 8 },
                { d: "2024-07-01", v: 6 },
                { d: "2024-08-01", v: 6 },
                { d: "2024-09-01", v: 9 },
                { d: "2024-10-01", v: 15 },
                { d: "2024-11-01", v: 17 },
                { d: "2024-12-01", v: 17 },
                { d: "2025-01-01", v: 19 },
                { d: "2025-02-01", v: 23 },
                { d: "2025-03-01", v: 26 },
                { d: "2025-04-01", v: 28 },
                { d: "2025-05-01", v: 28 },
                { d: "2025-06-01", v: 26 },
                { d: "2025-07-01", v: 21 },
                { d: "2025-08-01", v: 23 },
                { d: "2025-09-01", v: 31 },
                { d: "2025-10-01", v: 33 },
                { d: "2025-11-01", v: 42 },
                { d: "2025-12-01", v: 42 },
                { d: "2026-01-01", v: 41 },
                { d: "2026-02-01", v: 42 },
                { d: "2026-03-01", v: 50 },
                { d: "2026-04-01", v: 57 },
                { d: "2026-05-01", v: 54 },
                { d: "2026-06-01", v: 43 },
                { d: "2026-07-01", v: 41 },
                { d: "2026-08-01", v: 44 },
                { d: "2026-09-01", v: 87 },
              ],
            },
            {
              key: "runclub",
              label: "run club",
              color: "#4ADE80",
              points: [
                { d: "2024-01-01", v: 3 },
                { d: "2024-02-01", v: 3 },
                { d: "2024-03-01", v: 3 },
                { d: "2024-04-01", v: 3 },
                { d: "2024-05-01", v: 4 },
                { d: "2024-06-01", v: 4 },
                { d: "2024-07-01", v: 3 },
                { d: "2024-08-01", v: 4 },
                { d: "2024-09-01", v: 4 },
                { d: "2024-10-01", v: 3 },
                { d: "2024-11-01", v: 3 },
                { d: "2024-12-01", v: 3 },
                { d: "2025-01-01", v: 3 },
                { d: "2025-02-01", v: 3 },
                { d: "2025-03-01", v: 4 },
                { d: "2025-04-01", v: 4 },
                { d: "2025-05-01", v: 5 },
                { d: "2025-06-01", v: 5 },
                { d: "2025-07-01", v: 5 },
                { d: "2025-08-01", v: 8 },
                { d: "2025-09-01", v: 6 },
                { d: "2025-10-01", v: 6 },
                { d: "2025-11-01", v: 6 },
                { d: "2025-12-01", v: 6 },
                { d: "2026-01-01", v: 7 },
                { d: "2026-02-01", v: 8 },
                { d: "2026-03-01", v: 7 },
                { d: "2026-04-01", v: 10 },
                { d: "2026-05-01", v: 10 },
                { d: "2026-06-01", v: 10 },
                { d: "2026-07-01", v: 10 },
                { d: "2026-08-01", v: 7 },
                { d: "2026-09-01", v: 7 },
              ],
            },
            {
              key: "pickleball",
              label: "pickleball",
              color: "#FDE047",
              points: [
                { d: "2024-01-01", v: 30 },
                { d: "2024-02-01", v: 34 },
                { d: "2024-03-01", v: 34 },
                { d: "2024-04-01", v: 38 },
                { d: "2024-05-01", v: 41 },
                { d: "2024-06-01", v: 45 },
                { d: "2024-07-01", v: 49 },
                { d: "2024-08-01", v: 49 },
                { d: "2024-09-01", v: 43 },
                { d: "2024-10-01", v: 41 },
                { d: "2024-11-01", v: 45 },
                { d: "2024-12-01", v: 45 },
                { d: "2025-01-01", v: 42 },
                { d: "2025-02-01", v: 45 },
                { d: "2025-03-01", v: 49 },
                { d: "2025-04-01", v: 50 },
                { d: "2025-05-01", v: 51 },
                { d: "2025-06-01", v: 56 },
                { d: "2025-07-01", v: 60 },
                { d: "2025-08-01", v: 66 },
                { d: "2025-09-01", v: 58 },
                { d: "2025-10-01", v: 55 },
                { d: "2025-11-01", v: 56 },
                { d: "2025-12-01", v: 55 },
                { d: "2026-01-01", v: 53 },
                { d: "2026-02-01", v: 57 },
                { d: "2026-03-01", v: 65 },
                { d: "2026-04-01", v: 80 },
                { d: "2026-05-01", v: 78 },
                { d: "2026-06-01", v: 74 },
                { d: "2026-07-01", v: 66 },
                { d: "2026-08-01", v: 68 },
                { d: "2026-09-01", v: 68 },
              ],
            },
            {
              key: "bouldering",
              label: "bouldering",
              color: "#A78BFA",
              ghost: true,
              points: [
                { d: "2024-01-01", v: 3 },
                { d: "2024-02-01", v: 4 },
                { d: "2024-03-01", v: 5 },
                { d: "2024-04-01", v: 5 },
                { d: "2024-05-01", v: 4 },
                { d: "2024-06-01", v: 5 },
                { d: "2024-07-01", v: 5 },
                { d: "2024-08-01", v: 7 },
                { d: "2024-09-01", v: 5 },
                { d: "2024-10-01", v: 4 },
                { d: "2024-11-01", v: 4 },
                { d: "2024-12-01", v: 4 },
                { d: "2025-01-01", v: 5 },
                { d: "2025-02-01", v: 4 },
                { d: "2025-03-01", v: 4 },
                { d: "2025-04-01", v: 5 },
                { d: "2025-05-01", v: 4 },
                { d: "2025-06-01", v: 5 },
                { d: "2025-07-01", v: 5 },
                { d: "2025-08-01", v: 5 },
                { d: "2025-09-01", v: 5 },
                { d: "2025-10-01", v: 5 },
                { d: "2025-11-01", v: 5 },
                { d: "2025-12-01", v: 5 },
                { d: "2026-01-01", v: 5 },
                { d: "2026-02-01", v: 5 },
                { d: "2026-03-01", v: 5 },
                { d: "2026-04-01", v: 5 },
                { d: "2026-05-01", v: 7 },
                { d: "2026-06-01", v: 5 },
                { d: "2026-07-01", v: 5 },
                { d: "2026-08-01", v: 5 },
                { d: "2026-09-01", v: 5 },
              ],
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "Fitness racing is the empty column on the whole board, which is what an early signal looks like in a grid. You already share the run-club column with Lululemon and the padel column with it too, on two plays each. Red Bull owns motorsport here; your four Mercedes and Audi plays are a fifth of its count and better received than most of them.",
          title: "Who on the board plays which sport",
          provenance: "measured",
          note: "Each brand's measured plays on seven sports since January, counted from the record's titles and summaries and scaled to the busiest brand on each column; a column where one play reads one hundred is a step, not a lead. Tap a cell for the plays.",
          cols: [
            "Run clubs",
            "Fitness racing",
            "Padel",
            "Motorsport",
            "Women's sport",
            "Skate",
            "Cycling",
          ],
          rows: [
            {
              label: "Adidas",
              cells: [
                {
                  v: 100,
                  note: "Twelve, the busiest run shelf on the board with Lululemon's. The Berlin city night, the Eugene demo run, the Evo 3 drops, the Song for the Mute campaign, the SATISFY and BAPE Adizeros. One of them a hosted night, and it is the best-read of the twelve.",
                },
                {
                  v: 0,
                  note: "None. Nobody on the board has one. Your Dropset Elite, the first shoe built for the race, is not on the record yet.",
                },
                {
                  v: 100,
                  note: "Two, and a two-play column: the Metalbone racket fronted by Ale Galán, not read yet, and the World Cup racket collection, read at sixty-seven. Both rackets under licence, neither a court.",
                },
                {
                  v: 18,
                  note: "Four, a fifth of Red Bull's count: Original Forever, read at eighty-seven and the best-received sport play you own outside football; the Mercedes Blue Wonder collection at seventy-three; the Audi collection; the Super Bowl brand hub.",
                },
                {
                  v: 100,
                  note: "Four, level with Nike: the Tate McRae Climacool campaign read at sixty-seven, the Cunningham player edition, the Copper capsule, the Hibbett launch. Every one a player and a product, none a night.",
                },
                {
                  v: 75,
                  note: "Six: Thrasher × Argentina read three times running, the Adimatic by Jamal Smith, Temple of Skate, the Parallels series. A lane you play well in a sport whose participation is falling.",
                },
                {
                  v: 0,
                  note: "None. The Freerider relaunch and the Samba Climbing shoe are not on the record yet; you own Five Ten and have no play here.",
                },
              ],
            },
            {
              label: "Lululemon",
              cells: [
                {
                  v: 100,
                  note: "Twelve: SeaWheeze, the Stoneridge run club, the Running Truth campaign, Lewis Hamilton's rest day. The one brand that hosts a race of its own on this board, read at seventy-three.",
                },
                { v: 0, note: "None. Nobody on the board has one." },
                {
                  v: 100,
                  note: "Two, a step not a lead: the Trafford Centre padel pop-up, two weeks of sessions beside a new store, and its sibling play. Not read.",
                },
                {
                  v: 9,
                  note: "Two, both the Lewis Hamilton ambassadorship. A driver in the kit, no paddock.",
                },
                { v: 0, note: "None on the record since January." },
                { v: 0, note: "None." },
                { v: 0, note: "None." },
              ],
            },
            {
              label: "Nike",
              cells: [
                {
                  v: 58,
                  note: "Seven running plays on the record, the second-busiest shelf on this column; the women-only night races it runs are not on the record yet.",
                },
                { v: 0, note: "None. Nobody on the board has one." },
                {
                  v: 0,
                  note: "None on the record; the three rackets it showed in July arrive next year.",
                },
                { v: 0, note: "None." },
                {
                  v: 100,
                  note: "Four, level with you: the A'ja Wilson signature ad among them, the strongest women's play on the board at fifty-one and read at eighty.",
                },
                {
                  v: 100,
                  note: "Eight, the busiest skate shelf on the board.",
                },
                { v: 0, note: "None." },
              ],
            },
            {
              label: "Red Bull",
              cells: [
                {
                  v: 8,
                  note: "One: the Cyborg Season Ultra 600, the strongest run play on the board at forty-seven.",
                },
                { v: 0, note: "None. Nobody on the board has one." },
                {
                  v: 50,
                  note: "One, which reads fifty on a two-play column: Premier Padel in Bordeaux, not read.",
                },
                {
                  v: 100,
                  note: "Twenty-two, the busiest cell on the grid and the team's own sport. The column is scaled to it, which is why every other brand reads small here.",
                },
                { v: 0, note: "None." },
                { v: 38, note: "Three skate plays on the record." },
                {
                  v: 100,
                  note: "Seven, the busiest cycling shelf on the board; the bike brand by default.",
                },
              ],
            },
            {
              label: "Louis Vuitton",
              cells: [
                { v: 0, note: "None." },
                { v: 0, note: "None. Nobody on the board has one." },
                { v: 0, note: "None." },
                {
                  v: 9,
                  note: "Two: the Miami Grand Prix trophy trunk, graded forty-eight and read at seventy-three, the strongest motorsport play on the board that is not a film.",
                },
                { v: 0, note: "None." },
                { v: 25, note: "Two skate plays on the record." },
                {
                  v: 14,
                  note: "One: the Pinarello bike on the runway, graded thirty-nine and read at sixty-seven.",
                },
              ],
            },
            {
              label: "Gucci",
              cells: [
                { v: 0, note: "None." },
                { v: 0, note: "None. Nobody on the board has one." },
                {
                  v: 50,
                  note: "One, which reads fifty on a two-play column: the Padel Invitational at the Sydney Opera House, read at sixty-seven, the best-received padel play on the board.",
                },
                {
                  v: 9,
                  note: "Two: the Alpine collection, graded forty-four and read at sixty and forty-seven.",
                },
                { v: 0, note: "None." },
                { v: 0, note: "None." },
                { v: 0, note: "None." },
              ],
            },
            {
              label: "Tesla",
              cells: [
                { v: 0, note: "None." },
                { v: 0, note: "None. Nobody on the board has one." },
                {
                  v: 0,
                  note: "None; its two paddle plays are pickleball, the lane that cooled.",
                },
                { v: 0, note: "None." },
                { v: 0, note: "None." },
                { v: 0, note: "None." },
                {
                  v: 43,
                  note: "Three: the Balance Bike among them, graded fifty-four, the strongest cycling play on the board.",
                },
              ],
            },
            {
              label: "Netflix",
              cells: [
                { v: 0, note: "None." },
                { v: 0, note: "None. Nobody on the board has one." },
                { v: 0, note: "None." },
                { v: 5, note: "One motorsport play on the record." },
                { v: 0, note: "None." },
                { v: 0, note: "None." },
                { v: 14, note: "One cycling play on the record." },
              ],
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "Your crowd reads a room before it reads a shoe. The night in Berlin and the Home of Soccer were praised at seventy-three; the five-hundred-dollar shoe that won London was read at seven. The paddock is your best-received sport since you doubled into it. Fitness racing is the empty lane, and the band there is nobody's record yet.",
          title: "Your sports shelf",
          provenance: "measured",
          unit: "strength of the play · 0–100",
          note: "Every sport play on your record since January, by lane, on one scale. Bands are the board's range on that lane, typical to ceiling; the ring is the field's strongest play there; the dots are yours. Received is the best presence the crowd gave any play on the lane. Tap a lane for the read.",
          rows: [
            {
              id: "run-clubs",
              label: "Run clubs",
              sub: "the night run, the drop",
              typical: 25,
              ceiling: 38,
              best: {
                brandName: "Red Bull",
                title: "Cyborg Season Ultra 600",
                pts: 47,
              },
              received: 73,
              own: [
                { title: "Adizero Adios Pro Evo 3, limited", pts: 68 },
                { title: "Song for the Mute, Run In Love", pts: 42 },
                { title: "BAPE × Adizero EVO SL", pts: 40 },
                { title: "SATISFY × Adios Pro 4", pts: 39 },
                { title: "Adidas Runners City Night Berlin", pts: 24 },
                { title: "Hyperboost demo run, Eugene", pts: 19 },
              ],
              note: "Twelve plays, the busiest run shelf on the board with Lululemon's. The Berlin night graded twenty-four and read seventy-three, the widest gap between grade and read on your record; the five-hundred-dollar shoe graded sixty-eight and read seven. The crowd told you which of the two it wanted.",
            },
            {
              id: "motorsport",
              label: "Motorsport",
              sub: "the paddock you doubled",
              typical: 33,
              ceiling: 38,
              best: {
                brandName: "Louis Vuitton",
                title: "F1 Miami Grand Prix Trophy Trunk",
                pts: 48,
              },
              received: 87,
              own: [
                { title: "Original Forever", pts: 53 },
                { title: "Mercedes-AMG Petronas, Blue Wonder", pts: 37 },
                { title: "Audi Revolut F1 collection", pts: 33 },
                { title: "Super Bowl brand hub", pts: 21 },
              ],
              note: "The best-received sport on your shelf outside football. Original Forever read eighty-seven, the Mercedes collection seventy-three. You doubled into the paddock this year and the crowd came with you; the lane is a position to extend, not a signal to catch.",
            },
            {
              id: "padel",
              label: "Padel",
              sub: "the racket, not the room",
              typical: 29,
              ceiling: 29,
              best: {
                brandName: "Gucci",
                title: "Padel Invitational, Sydney Opera House",
                pts: 29,
              },
              received: 67,
              own: [
                { title: "Metalbone racket, Ale Galán", pts: 30 },
                { title: "World Cup racket collection", pts: 28 },
              ],
              note: "Four brands, six plays, every one a racket, a pop-up or an evening; the band is flat because nobody has brought a club. Your racket collection read sixty-seven, the same as Gucci's night at the Opera House. The room is the one thing in this sport no brand on the board owns.",
            },
            {
              id: "womens",
              label: "Women's sport",
              sub: "the player edition",
              typical: 33,
              ceiling: 34,
              best: {
                brandName: "Nike",
                title: "A'ja Wilson signature ad",
                pts: 51,
              },
              received: 80,
              own: [
                { title: "Cunningham Crazy Energy PE", pts: 36 },
                { title: "Tate McRae Climacool", pts: 33 },
                { title: "Copper × Ryoko Rain", pts: 27 },
                { title: "Hibbett launch event", pts: 25 },
                { title: "WNFC video", pts: 18 },
              ],
              note: "Five plays, level with Nike on count and under it on strength. The McRae campaign read sixty-seven and the Cunningham edition sold out in an hour; what you do not have is a signature shoe, and Nike's two sold out in a day. A lane going mainstream fast, and a shift row rather than a move.",
            },
            {
              id: "skate",
              label: "Skate",
              sub: "the feed's sport, falling",
              typical: 33,
              ceiling: 39,
              best: {
                brandName: "UGG",
                title: "Palace × UGG",
                pts: 43,
              },
              received: 73,
              own: [
                { title: "Thrasher × Argentina", pts: 39 },
                { title: "Adimatic by Jamal Smith", pts: 34 },
                { title: "Temple of Skate", pts: 33 },
                { title: "Parallels series", pts: 31 },
              ],
              note: "Six plays inside the board's band, the Thrasher collab read three windows running. The feed loves the sport and participation is falling, so this is culture after its peak, a lane to keep and not to bet on.",
            },
            {
              id: "fitness-racing",
              label: "Fitness racing",
              sub: "the lane nobody holds",
              typical: 25,
              ceiling: 38,
              status: "recommended",
              note: "Empty on your shelf and on the whole board. Your shoe for it, the Dropset Elite, is not on the record yet and the race's name belongs to a rival to 2030. The band is the run-club band standing in, because nobody's record exists here. This is the row the moves are about.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "The plays that landed sold a night, a paddock or a crowd. The two sold as a record-breaking shoe are the only ones read at nothing or below. Each of the three moves is a room first and a product second.",
          title: "Strength against reception",
          provenance: "measured",
          mode: "pair",
          a: { label: "Strength", color: "#FDE047" },
          b: { label: "Reception", color: "#4ADE80" },
          note: "Eight sport plays from your own record: how strongly each was graded on paper against the net reception the crowd gave it in its first window. The rows with a tail were read at nothing or below. Tap a row for the read.",
          rows: [
            {
              id: "original-forever",
              label: "Original Forever",
              sub: "motorsport · a film",
              a: 53,
              b: 87,
              note: "The best-received sport play on your record outside football, a film about the paddock and not a product in it.",
            },
            {
              id: "home-of-soccer",
              label: "Home of Soccer",
              sub: "football · a room",
              a: 48,
              b: 73,
              note: "A place to be during the World Cup, graded high and read higher. The mainstream lane, and still the room carried it.",
            },
            {
              id: "berlin-night",
              label: "Runners City Night Berlin",
              sub: "running · a night",
              a: 24,
              b: 73,
              note: "Graded twenty-four, read seventy-three, the widest gap on your record. A run after dark in one city, and the crowd treated it like a headline.",
            },
            {
              id: "blue-wonder",
              label: "Mercedes Blue Wonder",
              sub: "motorsport · a collection",
              a: 37,
              b: 73,
              note: "Race-day wear with a team's crowd already attached, read three windows running.",
            },
            {
              id: "padel-rackets",
              label: "World Cup padel rackets",
              sub: "padel · a collection",
              a: 28,
              b: 67,
              note: "Your one padel play that was read, and it read as well as Gucci's night at the Opera House. The sport is culture already; the racket borrowed it.",
            },
            {
              id: "mcrae",
              label: "Tate McRae Climacool",
              sub: "women's sport · a face",
              a: 33,
              b: 67,
              note: "A singer and three athletes in one campaign, read twice. The crowd arrived for the people.",
            },
            {
              id: "evo3-limited",
              label: "Adizero Evo 3, limited",
              sub: "running · a record shoe",
              a: 68,
              b: 7,
              tail: "read 7",
              note: "The strongest sport play on this list on paper, a five-hundred-dollar shoe that won London, and the crowd barely read it. A record is a fact; it is not a room.",
            },
            {
              id: "evo3-drop",
              label: "Evo 3, the drop",
              sub: "running · the merch",
              a: 51,
              b: 0,
              tail: "read −14",
              tailLow: true,
              note: "The one sport play here read below zero in its first window, and the second window praised it. Sold as performance it was argued with; sold as an object it was wanted.",
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "Every ritual you host runs on the aesthetic and the identity signal, and both work. The three strategies you rarely bring to a room, scarcity, opacity and fandom, are the three the crowd received best. A night with a ballot, a court you have to be invited to, a crowd that comes back. That is where the moves sit.",
          title: "Which strategy carries a ritual",
          provenance: "measured",
          x: {
            label: "How often you play it",
            low: "never",
            high: "every night",
            hint: "your events and experiences since January that carry each cultural strategy, as a share of the busiest one",
          },
          y: {
            label: "How the crowd received it",
            low: "silent",
            high: "praised",
            hint: "the valence the crowd gave the rituals carrying each strategy on your measured record, as a share of the best, scarcity, which reads ninety",
          },
          quadrants: {
            tr: "Your habit, and it works",
            tl: "Rare, and it works",
            br: "Your habit, ignored",
            bl: "Never played",
          },
          note: "The five cultural strategies on your hundred events and experiences since January. Across is how often each one is played on a ritual; up is the valence the crowd gave the rituals that carried it, against the best-received strategy. Dot size is the number of plays. Tap a dot for the read.",
          wLabel: "plays",
          open: "scarcity",
          points: [
            {
              id: "aesthetic",
              label: "Aesthetic innovation",
              era: "The strategies you play",
              color: "#FDE047",
              x: 97,
              y: 81,
              w: 82,
              status: "current",
              note: "Eighty-two of your hundred rituals carry it, the look and the stage. Received well, a valence of thirty-seven and a half, and still the fourth of five. Your default, and the one every move wears underneath the rarer one.",
            },
            {
              id: "identity",
              label: "Identity signal",
              era: "The strategies you play",
              color: "#60A5FA",
              x: 71,
              y: 74,
              w: 58,
              note: "Fifty-eight rituals, the flag and the crest, the home of soccer, the city night. The lowest valence of the five on a ritual and still positive. The strategy that says who the night is for; the moves pair it with scarcity.",
            },
            {
              id: "scarcity",
              label: "Scarcity",
              short: "The ballot",
              era: "The strategies you rarely bring",
              color: "#FB923C",
              x: 24,
              y: 90,
              w: 17,
              status: "recommended",
              note: "Seventeen rituals and the best valence of the five. Scarcity is the strategy of the limited place, the ballot, the start line you have to win. On a shoe your crowd argued with it; on a night they queued. The first move's second strategy.",
            },
            {
              id: "opacity",
              label: "Opacity",
              short: "Invitation only",
              era: "The strategies you rarely bring",
              color: "#B388FF",
              x: 19,
              y: 85,
              w: 17,
              status: "recommended",
              note: "Seventeen rituals, among the best received. Opacity is the strategy of withholding, the room you have to be invited into. Your least-played strategy anywhere on the record and the shape the padel club takes.",
            },
            {
              id: "fandom",
              label: "Fandom",
              era: "The strategies you rarely bring",
              color: "#FF7AB8",
              x: 13,
              y: 90,
              w: 14,
              note: "Fourteen rituals, level with scarcity on valence. A crowd that comes back is the strategy you bring to a room least, and the night run is built on it.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Gen Z fills the first night and Millennials keep coming back. The racing core is in its thirties and already pays for a place on the start line; the padel room is where that crowd goes on a Friday instead of a bar. The generation that made pickleball mainstream is the one these moves are not for.",
          title: "Who carries it, who keeps it",
          provenance: "projected",
          note: "Five generations scored for how much of a fitness-racing night and a padel room's first year each would carry, from your record, the participation reads and what each crowd says it wants, and the clock each runs on. Tap a crowd for the drivers.",
          rows: [
            {
              id: "gen-z",
              label: "Gen Z",
              context: "the run with a date in it",
              score: 84,
              role: "First-week engine",
              horizon: "short",
              drivers: [
                "Exercises to meet people more than any other generation, and one in five had a date through a run club",
                "Logs races at a rate rising by a third a year, the five-kilometre and the ten",
                "Would rather spend on gear than on a date, by its own account",
                "Half of Formula 1's Gen Z fans are women, the crowd the paddock you doubled into brought with it",
              ],
            },
            {
              id: "millennials",
              label: "Millennials",
              context: "the start line, the members' court",
              score: 78,
              role: "Slow compounder",
              horizon: "long",
              drivers: [
                "The fitness-racing core, the largest age band on the start line",
                "The members' padel club and the deal-making court, the crowd that calls it the new golf",
                "The marathon ballot's heart, a million applicants for forty thousand places",
              ],
            },
            {
              id: "gen-x",
              label: "Gen X",
              context: "tennis players finding padel",
              score: 55,
              role: "Quiet adopter",
              horizon: "long",
              drivers: [
                "Two-thirds of padel players also play tennis, and this is the tennis crowd",
                "The golf and racquet generation, with the weekend race as a family calendar",
              ],
            },
            {
              id: "gen-alpha",
              label: "Gen Alpha",
              context: "the film and the feed",
              score: 38,
              role: "Watches",
              horizon: "short",
              drivers: [
                "Formula 1 through the film and the feed, the sport it knows first",
                "The skate and basketball screens, not yet in the room",
              ],
            },
            {
              id: "boomers",
              label: "Boomers",
              context: "pickleball's core",
              score: 28,
              role: "Elsewhere",
              horizon: "long",
              drivers: [
                "The crowd that made pickleball mainstream, the one sport here that never became culture",
                "The lane the moves do not price",
              ],
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "The bottom-right corner is the answer. Fitness racing and run clubs are dressed for and talked about before they are big, and both are still climbing. Padel has already crossed the midline on size, which is why its window is a market and not a sport. Pickleball sits alone on the left, the most people and the least culture, and the one lane that is shrinking.",
          title: "Where each sport sits",
          provenance: "observed",
          x: {
            label: "Culture: feed, fit, night",
            low: "undressed",
            high: "a fashion week",
            hint: "how far each sport has become something people dress for, post and go out to, an author's read of this year's public facts, relative not counted",
          },
          y: {
            label: "People in it",
            low: "a niche",
            high: "the masses",
            hint: "how many people play or follow it, relative to the largest crowd on this chart, Formula 1's fans and America's road runners; a read, not a count",
          },
          quadrants: {
            tr: "Culture and mainstream",
            tl: "Big, not culture",
            br: "Culture before mainstream",
            bl: "Neither yet",
          },
          note: "Eleven sports placed by how much culture each carries and how many people are in it, an author's read of the dated public facts behind this answer, not a measurement. Dot size is momentum, how fast the sport grew this year. The haloed dots are the two the moves are about; the hollow one is the lane you are already in. Tap a dot for the read.",
          wLabel: "momentum",
          open: "fitness-racing",
          points: [
            {
              id: "f1",
              label: "Formula 1",
              era: "You are in",
              color: "#FDE047",
              x: 92,
              y: 88,
              w: 50,
              status: "current",
              note: "Culture and mainstream at once: the largest fan base on this chart, nearly half its new fans women, the paddock a fashion week with a ten-year luxury partner. You doubled into it this year and it is your best-received sport outside football. A position to extend, not a signal.",
            },
            {
              id: "padel",
              label: "Padel",
              era: "Culture first",
              color: "#FB923C",
              x: 80,
              y: 58,
              w: 70,
              note: "Already culture, the members' club, the Opera House night, the watch on the champion's wrist, and already mainstream in Europe, where the courts outran the crowd and clubs are closing. Across the midline on size, so the window is the one market still short of courts, the US.",
            },
            {
              id: "run-clubs",
              label: "Run clubs",
              short: "Run clubs",
              era: "The signal",
              color: "#4ADE80",
              x: 75,
              y: 40,
              w: 80,
              status: "recommended",
              note: "A night out with a route. Clubs multiplied on the one app that counts them, the marathon ballot grew by a third, and a rival's women-only night races drew fifty thousand in their first year. Dressed for and posted before it is big. Your Berlin night is the proof on your own record.",
            },
            {
              id: "womens-basketball",
              label: "Women's basketball",
              era: "Culture first",
              color: "#FB923C",
              x: 70,
              y: 48,
              w: 65,
              note: "Culture going mainstream fast: record attendance, sold-out signature shoes in a day, a billion-dollar industry doubling. You have a player edition that sold out in an hour and no signature shoe since Candace Parker. A shift row, not a move, because the window here is a player and a shoe, not a room.",
            },
            {
              id: "golf",
              label: "Golf's youth wave",
              era: "Mass first",
              color: "#94A3B8",
              x: 55,
              y: 62,
              w: 40,
              note: "The largest on-course cohort is now under thirty-five and the simulator bays made a second sport of it. Big and getting dressed, slowly; the streetwear golf labels are the culture, the courses are the mass.",
            },
            {
              id: "skate",
              label: "Skate",
              era: "Culture first",
              color: "#FB923C",
              x: 66,
              y: 25,
              w: 10,
              note: "The feed's sport and a falling one, participation down after the Olympic years. Culture after its peak: keep the shelf you have, do not bet the next room on it.",
            },
            {
              id: "fitness-racing",
              label: "Fitness racing",
              short: "Fitness racing",
              era: "The signal",
              color: "#22D3EE",
              x: 62,
              y: 30,
              w: 100,
              status: "recommended",
              note: "The steepest curve on the chart on every axis at once: athletes doubling season on season, search up six-fold, a luxury owner, an Olympic pathway signed this week. A rival holds the race's name to the end of the decade and nobody holds its culture. The empty column on your board and the first move.",
            },
            {
              id: "climbing",
              label: "Climbing",
              era: "Culture first",
              color: "#FB923C",
              x: 58,
              y: 22,
              w: 20,
              note: "The feed loves it and the search line is flat; new gyms are opening more slowly and the operators say the boom is over. You own the rubber and just shipped a Samba for the wall, a live test and too new to read. Do not price the lane by its feed.",
            },
            {
              id: "road-running",
              label: "Road running",
              era: "Mass first",
              color: "#94A3B8",
              x: 45,
              y: 95,
              w: 30,
              note: "The largest participation crowd here and a flat one at its core; the casual runner grows while the committed one does not. Mainstream for a generation. The run club is the piece of it that became culture, which is why it has its own dot.",
            },
            {
              id: "cycling",
              label: "Cycling",
              era: "Mass first",
              color: "#94A3B8",
              x: 30,
              y: 55,
              w: 5,
              note: "Adult riders fell again this year and sales with them; gravel is the one corner growing and a luxury bike on a runway the one fashion moment. Big, shrinking, undressed. You have no play here and this chart says you lose nothing by it.",
            },
            {
              id: "pickleball",
              label: "Pickleball",
              era: "Mass first",
              color: "#94A3B8",
              x: 18,
              y: 70,
              w: 10,
              note: "Twenty-four million players in one country, growth down to a percent this half-year, the largest franchisor bankrupt, no fashion search term anywhere. Mainstream without culture, the control for the whole chart. Your paddles are a licence and should stay one.",
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three rooms and one rule. Host the night, never only sell the shoe. The racing night does the signal, the padel club does the window, the night run does the crowd you already have. Together they are worth about two points, most of it from the shape your crowd has praised more than any product.",
          title: "Three moves, priced",
          provenance: "projected",
          plays: [
            {
              name: "Hybrid Night by Adidas Runners — a Friday-night fitness race you host in Berlin, London and New York under the ATHX calendar: eight stations and a run, a ballot for the start line, a Dropset Elite on every starter",
              itemType: "experience",
              window:
                "First nights in February 2027, before the sport's world championship in June; a city a month after that",
              strategies: [
                { code: "identity_signal", fit: 0.6 },
                { code: "scarcity", fit: 0.4 },
              ],
              why: "Fitness racing has a million and a half athletes, a luxury owner and an Olympic pathway, and nobody owns its culture. The rights cover the race and not the night. Your record says a hosted night is your best-received shape, and scarcity on a ritual is your best-received strategy and one you almost never bring.",
              effect: {
                label: "CIQ",
                delta: 0.9,
                series: [0, 0.3, 0.6, 0.8, 0.9],
              },
              precedents: 3,
              reception:
                "your hosted nights read 53 to 73 on your record; the board's hosted races read 73 at best",
              similar: [
                {
                  brand: "red-bull",
                  brandName: "Red Bull",
                  title: "Cyborg Season Ultra 600",
                  pts: 46.5,
                },
                {
                  brand: "lululemon",
                  brandName: "Lululemon",
                  title: "SeaWheeze Half Marathon and Sunset Festival",
                  pts: 20.7,
                },
                {
                  brand: "gucci",
                  brandName: "Gucci",
                  title: "Padel Invitational at Sydney Opera House",
                  pts: 29.4,
                },
              ],
            },
            {
              name: "Spezial Padel Club — a Terrace-coded members' court in New York and Miami with Reserve Padel, invitation first and open bookings by summer, the kit in the Spezial colours",
              itemType: "experience",
              window:
                "Open for the spring 2027 season, a year before Nike's rackets; the second city by the autumn",
              strategies: [
                { code: "opacity", fit: 0.5 },
                { code: "aesthetic_innovation", fit: 0.4 },
              ],
              why: "Padel is already culture and already mainstream where the courts outran the crowd. The US has a million players on a thousand courts, and your padel is a racket under licence. The room is the one thing in the sport you do not yet own. Opacity is your least-played strategy on a ritual and among the best received.",
              effect: {
                label: "CIQ",
                delta: 0.7,
                series: [0, 0.25, 0.5, 0.65, 0.7],
              },
              precedents: 3,
              reception:
                "the board's padel plays read 0 to 67; your own racket collection read 67",
              similar: [
                {
                  brand: "gucci",
                  brandName: "Gucci",
                  title: "Padel Invitational at Sydney Opera House",
                  pts: 29.4,
                },
                {
                  brand: "lululemon",
                  brandName: "Lululemon",
                  title: "Trafford Centre Padel Pop-up",
                  pts: 25.8,
                },
                {
                  brand: "louis-vuitton",
                  brandName: "Louis Vuitton",
                  title: "Louis Vuitton x Pinarello Bike",
                  pts: 39.0,
                },
              ],
            },
            {
              name: "EVO SL Night Run — a monthly ten-kilometre run after dark in ten Adidas Runners cities, women's waves first, with a run-club edition of the EVO SL sold the morning after each",
              itemType: "event",
              window:
                "From March 2027 through the autumn marathons; the edition changes city by city",
              strategies: [
                { code: "fandom", fit: 0.5 },
                { code: "aesthetic_innovation", fit: 0.4 },
              ],
              why: "Run clubs tripled on the one app that counts them, London's ballot grew by a third and Gen Z runs to meet people. Your EVO SL already launched with a run club in Sydney, and fandom is the strategy your crowd rewards most on a ritual and the one you bring least.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.2, 0.4, 0.55, 0.6],
              },
              precedents: 3,
              reception:
                "your run nights read 53 to 73; your run shoes sold as records read 7 and below",
              similar: [
                {
                  brand: "lululemon",
                  brandName: "Lululemon",
                  title: "SeaWheeze Half Marathon and Sunset Festival",
                  pts: 20.7,
                },
                {
                  brand: "jacquemus",
                  brandName: "Jacquemus",
                  title: "Jacquemus x Nike Moon Shoe",
                  pts: 45.4,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "Naomi Osaka's French Open Nike x Germanier debut",
                  pts: 56.2,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on your measured record and the public facts in the file header, and compound with your current course. No move claims the race's name; its rights belong to a rival until the end of the decade. The night is yours.",
        },
        {
          kind: "impact",
          title: "What the three moves carry",
          provenance: "projected",
          delta: 2.2,
          body: "About two points on your published score, from 85.32 to roughly 87.5, past the leader on the board. Most of it is a night you host, the shape your crowd has praised more than any shoe. The qualifier is the name. The race's rights belong to a rival to 2030, so the race is theirs and the night is yours. Sold as a room, the moves earn their price. Sold as a record shoe, London's winner read seven.",
        },
        {
          kind: "modelView",
          body: "The two sports becoming culture before they are big are the ones people queue for and dress for before anyone has sold them a thing. Fitness racing is the clearest tell this decade. A race that started in a Hamburg hall, bought by a luxury fund, on a path to the Olympics, and searched more every month, with its culture still unclaimed because the rights only cover the race. Running as a night out is the other, and it is the one your own record already proves. The night in Berlin was praised far above its grade, and the shoe that won a marathon was barely read.\n\nWhat can be read at your scale is the shape and not the lane. Your crowd rewards a room, an invitation and a crowd that comes back, and you bring those three strategies to a ritual less than any other. Padel tells the other half of the story, a sport that became culture first and then overbuilt, so the window is no longer the sport but the one market that is still short of courts. Pickleball is the warning. It went mainstream without ever becoming culture, and the people who built the courts are now in bankruptcy court. Climbing is the live test you have just shipped. The feed loves it, the search line is flat, and the shoe is too new to read.\n\nSo host before you sell. Put your name on the night, the court and the run, and let the shoe follow the room. Do not call any of it a race you do not own, and do not price the lane by its feed. Price it by whether people are queueing to get in.",
        },
      ],
    },
    {
      id: "next-gen-relevance",
      // where the next generation is leaving the brand, lane by lane. The
      // lead move is a room, not a shoe
      itemType: "experience",
      type: "audience",
      question: "Where is adidas losing relevance with the next generation?",
      aliases: [
        "is gen z moving on from adidas and where",
        "which next gen lanes are we losing and to whom",
        "where is adidas losing relevance with gen z",
        "where are we losing the next generation",
        "are we losing gen z",
        "are we losing relevance with young people",
        "is adidas still cool with teenagers",
        "where is adidas losing gen z and gen alpha",
        "which generation are we losing",
        "where is the next generation leaving us",
      ],
      askedOn: "2026-10-30",
      blocks: [
        {
          kind: "readout",
          provenance: "measured",
          verdict:
            "The next generation is not leaving your shoe. It is leaving the lanes around it: the running shoe she buys next, the kit he wears, the court, and the room under thirteen.",
        },
        {
          kind: "stats",
          provenance: "observed",
          insight:
            "Your name is holding among teenagers and the aisle around it is not. The one-point slip in the shoe is noise. The nine points she gives Hoka over you in running, the two percent who name your clothes and the fifteen points the athletic aisle has lost since the Samba year are the lanes. Relevance is leaving by the side doors, not the front.",
          items: [
            {
              label: "Teens who name you",
              value: "10%",
              hint: "share of this autumn's nine thousand US teenagers naming you their favourite footwear brand, second behind Nike. Eleven named you last year and seven three years ago. The shoe is holding",
            },
            {
              label: "Upper-income girls, athletic",
              value: "4%",
              hint: "share of upper-income teen girls naming you their athletic shoe this autumn, against thirteen for Hoka and twelve for On. The girl you won with the Samba buys her running shoe elsewhere",
            },
            {
              label: "Teens naming your apparel",
              value: "2%",
              hint: "share of US teens naming you their favourite clothing brand this autumn, ninth on the list, with a mall retailer ahead of you among boys. The kit is the widest gap",
            },
            {
              label: "Athletic share of the teen wallet",
              value: "29%",
              hint: "share of the teen fashion mindshare held by athletic brands this autumn, down from forty-four three years ago. The whole aisle is shrinking for the young, and the question is which door she walks out of",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The teenager's next purchase is a running shoe or a piece of clothing, and both lanes already have a young brand in them. Your running grows faster than the shelf and the teenager does not credit you with it yet. Your apparel grows faster still and she names a mall brand. The under-thirteens are on a platform where your only visit was somebody else's party.",
          title: "What the next generation is doing",
          provenance: "observed",
          note: "Six public numbers from the past year. Each line says what the figure counts and why it is here. The last one is the risk, not a signal.",
          rows: [
            {
              label: "Teen footwear spend",
              context:
                "Year-on-year change in what US teens report spending on shoes this autumn, after a six percent fall the year before, while their clothing spend grew seven. She is spending on clothes, not on the next pair.",
              value: "−1%",
            },
            {
              label: "Running shoes on the US shelf",
              context:
                "Dollar and unit growth of running footwear at US retail in the first half of this year, while sport-lifestyle shoes declined. The next shoe is a running shoe, and your own running grew twenty-eight percent in the spring quarter.",
              value: "+13%",
            },
            {
              label: "On's crowd under thirty-four",
              context:
                "Share of On's customers under thirty-four this summer by the brand's own account, with the Cloudtilt the shoe they come for. The young runner has a brand already.",
              value: "1 in 3",
            },
            {
              label: "Daily players under thirteen",
              context:
                "Share of Roblox's hundred and thirty-eight million daily users who are under thirteen this quarter, with another thirty-seven percent aged thirteen to seventeen. Two in three of the platform are the next generation, and you own no room there.",
              value: "34%",
            },
            {
              label: "Originals' following, four weeks",
              context:
                "Change in your Originals account's Instagram following over the past four weeks, while New Balance added sixty thousand and your main account a hundred and twelve thousand. The lifestyle house is the one standing still.",
              value: "−8K",
            },
            {
              label: "Shoe prices, the fastest rise in years",
              context:
                "Year-on-year rise in US retail footwear prices this May, the fastest in forty-five months, with children's shoes up two percent. The extra pair is the one a family drops first.",
              value: "+5.2%",
            },
          ],
        },
        {
          kind: "trendCompare",
          insight:
            "The Samba is the one line falling, a fifth lower on the two-year means and each spring lower than the last. The Speedcat, a rival's copy of your playbook, went from nothing to a fifth of the Samba's search and is already sliding. The 530 climbs slowly and the XT-6 is the one line still rising at the end. Nobody has the next Samba, and the shelf is moving to shoes with a sport in them.",
          title: "The next shoe, five lines",
          provenance: "observed",
          note: "Worldwide Google search interest for five shoes, monthly means from January 2024 to September 2026 on one scale. The busiest month of any of them reads 100. Every line steps up in the spring of this year, a platform-wide shift read as a step and not an event. The Gel-Kayano 14 is the ghost, the revival the feed talks about that search does not confirm. October is left off as a part month.",
          highlight: {
            from: "2026-01-01",
            to: "2026-02-28",
            label: "The winter floor",
          },
          series: [
            {
              key: "samba",
              label: "Adidas Samba",
              color: "#FB923C",
              points: [
                { d: "2024-01-01", v: 60 },
                { d: "2024-02-01", v: 73 },
                { d: "2024-03-01", v: 91 },
                { d: "2024-04-01", v: 100 },
                { d: "2024-05-01", v: 84 },
                { d: "2024-06-01", v: 77 },
                { d: "2024-07-01", v: 77 },
                { d: "2024-08-01", v: 81 },
                { d: "2024-09-01", v: 80 },
                { d: "2024-10-01", v: 72 },
                { d: "2024-11-01", v: 77 },
                { d: "2024-12-01", v: 73 },
                { d: "2025-01-01", v: 60 },
                { d: "2025-02-01", v: 63 },
                { d: "2025-03-01", v: 83 },
                { d: "2025-04-01", v: 78 },
                { d: "2025-05-01", v: 68 },
                { d: "2025-06-01", v: 60 },
                { d: "2025-07-01", v: 65 },
                { d: "2025-08-01", v: 77 },
                { d: "2025-09-01", v: 68 },
                { d: "2025-10-01", v: 59 },
                { d: "2025-11-01", v: 65 },
                { d: "2025-12-01", v: 63 },
                { d: "2026-01-01", v: 50 },
                { d: "2026-02-01", v: 50 },
                { d: "2026-03-01", v: 75 },
                { d: "2026-04-01", v: 81 },
                { d: "2026-05-01", v: 74 },
                { d: "2026-06-01", v: 58 },
                { d: "2026-07-01", v: 57 },
                { d: "2026-08-01", v: 65 },
                { d: "2026-09-01", v: 59 },
              ],
            },
            {
              key: "nb530",
              label: "New Balance 530",
              color: "#22D3EE",
              points: [
                { d: "2024-01-01", v: 20 },
                { d: "2024-02-01", v: 23 },
                { d: "2024-03-01", v: 31 },
                { d: "2024-04-01", v: 32 },
                { d: "2024-05-01", v: 27 },
                { d: "2024-06-01", v: 25 },
                { d: "2024-07-01", v: 27 },
                { d: "2024-08-01", v: 31 },
                { d: "2024-09-01", v: 29 },
                { d: "2024-10-01", v: 26 },
                { d: "2024-11-01", v: 33 },
                { d: "2024-12-01", v: 34 },
                { d: "2025-01-01", v: 30 },
                { d: "2025-02-01", v: 29 },
                { d: "2025-03-01", v: 38 },
                { d: "2025-04-01", v: 37 },
                { d: "2025-05-01", v: 33 },
                { d: "2025-06-01", v: 30 },
                { d: "2025-07-01", v: 32 },
                { d: "2025-08-01", v: 38 },
                { d: "2025-09-01", v: 33 },
                { d: "2025-10-01", v: 29 },
                { d: "2025-11-01", v: 35 },
                { d: "2025-12-01", v: 31 },
                { d: "2026-01-01", v: 27 },
                { d: "2026-02-01", v: 26 },
                { d: "2026-03-01", v: 39 },
                { d: "2026-04-01", v: 46 },
                { d: "2026-05-01", v: 40 },
                { d: "2026-06-01", v: 28 },
                { d: "2026-07-01", v: 30 },
                { d: "2026-08-01", v: 35 },
                { d: "2026-09-01", v: 33 },
              ],
            },
            {
              key: "speedcat",
              label: "Puma Speedcat",
              color: "#FDE047",
              points: [
                { d: "2024-01-01", v: 0 },
                { d: "2024-02-01", v: 0 },
                { d: "2024-03-01", v: 0 },
                { d: "2024-04-01", v: 0 },
                { d: "2024-05-01", v: 0 },
                { d: "2024-06-01", v: 1 },
                { d: "2024-07-01", v: 3 },
                { d: "2024-08-01", v: 3 },
                { d: "2024-09-01", v: 4 },
                { d: "2024-10-01", v: 4 },
                { d: "2024-11-01", v: 5 },
                { d: "2024-12-01", v: 7 },
                { d: "2025-01-01", v: 7 },
                { d: "2025-02-01", v: 8 },
                { d: "2025-03-01", v: 10 },
                { d: "2025-04-01", v: 10 },
                { d: "2025-05-01", v: 10 },
                { d: "2025-06-01", v: 10 },
                { d: "2025-07-01", v: 11 },
                { d: "2025-08-01", v: 13 },
                { d: "2025-09-01", v: 13 },
                { d: "2025-10-01", v: 11 },
                { d: "2025-11-01", v: 14 },
                { d: "2025-12-01", v: 17 },
                { d: "2026-01-01", v: 16 },
                { d: "2026-02-01", v: 14 },
                { d: "2026-03-01", v: 23 },
                { d: "2026-04-01", v: 35 },
                { d: "2026-05-01", v: 30 },
                { d: "2026-06-01", v: 19 },
                { d: "2026-07-01", v: 21 },
                { d: "2026-08-01", v: 24 },
                { d: "2026-09-01", v: 16 },
              ],
            },
            {
              key: "xt6",
              label: "Salomon XT-6",
              color: "#4ADE80",
              points: [
                { d: "2024-01-01", v: 1 },
                { d: "2024-02-01", v: 1 },
                { d: "2024-03-01", v: 1 },
                { d: "2024-04-01", v: 1 },
                { d: "2024-05-01", v: 1 },
                { d: "2024-06-01", v: 1 },
                { d: "2024-07-01", v: 1 },
                { d: "2024-08-01", v: 1 },
                { d: "2024-09-01", v: 1 },
                { d: "2024-10-01", v: 1 },
                { d: "2024-11-01", v: 2 },
                { d: "2024-12-01", v: 2 },
                { d: "2025-01-01", v: 1 },
                { d: "2025-02-01", v: 1 },
                { d: "2025-03-01", v: 1 },
                { d: "2025-04-01", v: 1 },
                { d: "2025-05-01", v: 1 },
                { d: "2025-06-01", v: 1 },
                { d: "2025-07-01", v: 2 },
                { d: "2025-08-01", v: 3 },
                { d: "2025-09-01", v: 2 },
                { d: "2025-10-01", v: 3 },
                { d: "2025-11-01", v: 4 },
                { d: "2025-12-01", v: 3 },
                { d: "2026-01-01", v: 4 },
                { d: "2026-02-01", v: 3 },
                { d: "2026-03-01", v: 4 },
                { d: "2026-04-01", v: 6 },
                { d: "2026-05-01", v: 5 },
                { d: "2026-06-01", v: 4 },
                { d: "2026-07-01", v: 3 },
                { d: "2026-08-01", v: 4 },
                { d: "2026-09-01", v: 5 },
              ],
            },
            {
              key: "kayano",
              label: "Asics Gel-Kayano 14",
              color: "#A78BFA",
              ghost: true,
              points: [
                { d: "2024-01-01", v: 1 },
                { d: "2024-02-01", v: 1 },
                { d: "2024-03-01", v: 1 },
                { d: "2024-04-01", v: 1 },
                { d: "2024-05-01", v: 1 },
                { d: "2024-06-01", v: 1 },
                { d: "2024-07-01", v: 1 },
                { d: "2024-08-01", v: 1 },
                { d: "2024-09-01", v: 1 },
                { d: "2024-10-01", v: 1 },
                { d: "2024-11-01", v: 1 },
                { d: "2024-12-01", v: 2 },
                { d: "2025-01-01", v: 1 },
                { d: "2025-02-01", v: 1 },
                { d: "2025-03-01", v: 1 },
                { d: "2025-04-01", v: 1 },
                { d: "2025-05-01", v: 1 },
                { d: "2025-06-01", v: 1 },
                { d: "2025-07-01", v: 1 },
                { d: "2025-08-01", v: 2 },
                { d: "2025-09-01", v: 1 },
                { d: "2025-10-01", v: 1 },
                { d: "2025-11-01", v: 2 },
                { d: "2025-12-01", v: 1 },
                { d: "2026-01-01", v: 1 },
                { d: "2026-02-01", v: 1 },
                { d: "2026-03-01", v: 2 },
                { d: "2026-04-01", v: 3 },
                { d: "2026-05-01", v: 3 },
                { d: "2026-06-01", v: 2 },
                { d: "2026-07-01", v: 1 },
                { d: "2026-08-01", v: 2 },
                { d: "2026-09-01", v: 2 },
              ],
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "You are the one athletic brand the girl names more than the boy, by six points, and the only one of the big three where that is true. It is the Samba's gift and its limit. The boy who left the Terrace went to a running shoe and named On and Asics, two brands that were not on his list two years ago. The lane you are losing is his, and it is a sport lane.",
          title: "Who she names, who he names",
          provenance: "observed",
          mode: "pair",
          a: { label: "Her", color: "#FF7AB8" },
          b: { label: "Him", color: "#60A5FA" },
          note: "Share of teenage girls and boys naming each brand their favourite shoe this autumn. A brand with nothing on his side is not in his top ten. Tap a row for the read.",
          rows: [
            {
              id: "nike",
              label: "Nike",
              sub: "the court, the default",
              a: 31,
              b: 56,
              note: "Still first on both sides and falling on both. Thirty-one of her, from fifty-six three years ago, and fifty-six of him, from sixty-seven. The front door is shrinking for the leader too.",
            },
            {
              id: "adidas",
              label: "Adidas",
              sub: "the Samba, the Terrace",
              a: 14,
              b: 8,
              note: "Fourteen of her, flat on the year and up from three in three years. Eight of him, one lower than last year. The one athletic brand she names more than he does.",
            },
            {
              id: "ugg",
              label: "UGG",
              sub: "the boot, her third",
              a: 10,
              b: 0,
              note: "Her third shoe and not in his ten at all. A non-athletic shoe climbing the girls' list, which is where the athletic aisle's share went.",
            },
            {
              id: "birkenstock",
              label: "Birkenstock",
              sub: "the sandal, climbing",
              a: 8,
              b: 3,
              note: "Up three points with her this year, the biggest climber on her list. The retailers that serve the young are the ones driving its American growth, by its own account.",
            },
            {
              id: "new-balance",
              label: "New Balance",
              sub: "the dad shoe, his equal",
              a: 7,
              b: 8,
              note: "Level with you on his side and one behind on hers, on a year its sales grew by a fifth. The brand that stayed credible in a sport and let the lifestyle shoe pull the young.",
            },
            {
              id: "converse",
              label: "Converse",
              sub: "the canvas, leaving",
              a: 6,
              b: 1,
              note: "Six of her, from nine, and one of him, from the fourth place he gave it two years ago. The youth heritage shoe, a third of its sales gone in a year.",
            },
            {
              id: "on",
              label: "On",
              sub: "the running shoe, arriving",
              a: 3,
              b: 3,
              note: "Three of each, and his fourth favourite from tenth two years ago. Second among upper-income teens' athletic shoes, ahead of you. The brand that took his running lane.",
            },
            {
              id: "asics",
              label: "Asics",
              sub: "the other running shoe",
              a: 1,
              b: 3,
              note: "His fifth favourite, from tenth in the spring of last year. With On, the second running brand to enter his top five inside two years.",
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "Her column is yours and his is leaving. The girl's lifestyle cells are the brightest on the map and her running cell among the darkest, while the boy's one bright cell is football. The gaming row is dark for every generation, and it is the row where the under-thirteens live.",
          title: "Where you stand, lane by generation",
          provenance: "projected",
          note: "Cell brightness is modelled resonance per lane and generation, zero to a hundred, from this autumn's teen survey, the brand's own quarter and the record's reads. Tap a cell for the read.",
          cols: ["Gen Alpha", "Gen Z, her", "Gen Z, him", "Millennials"],
          rows: [
            {
              label: "Terrace shoe",
              cells: [
                {
                  v: 48,
                  note: "UK kids aged seven to fourteen ranked you fourteenth last year, up fifteen places, on the Gazelle and their parents' music. The shoe reaches the child through the parent.",
                },
                {
                  v: 100,
                  note: "Fourteen percent of teen girls name you, flat on the year and up from three three years ago. The Jane, the Mule and the Loafer keep her.",
                },
                {
                  v: 44,
                  note: "Eight percent of boys, one lower than last year. The Terrace for him is the discounted shoe, by your own chief executive's account.",
                },
                {
                  v: 70,
                  note: "The crowd that bought the Samba first and still reads the Terrace collabs. The Kith Samba read seventy-three this spring.",
                },
              ],
            },
            {
              label: "Low profile, dressy",
              cells: [
                {
                  v: 20,
                  note: "A dressy shoe is not a child's shoe. The lane does not reach under thirteen.",
                },
                {
                  v: 86,
                  note: "The Tokyo, Taekwondo and Japan in dressier versions grow strongly by your own account. Jennie's ballet Superstar sits here, read sixty-seven twice.",
                },
                {
                  v: 30,
                  note: "A ballet flat and a loafer are hers. The low-profile shoe for him is the Speedcat's lane, and a rival's.",
                },
                {
                  v: 60,
                  note: "The Taekwondo was last year's most popular shoe among one magazine's readers and the Chinese track top read sixty-seven. The lane sells to her at every age.",
                },
              ],
            },
            {
              label: "Running shoe",
              cells: [
                {
                  v: 25,
                  note: "The child runs in what the parent buys. Your kids' running shoe has no play on the record this year.",
                },
                {
                  v: 18,
                  note: "Four percent of upper-income girls name you. Thirteen name Hoka and twelve name On.",
                },
                {
                  v: 34,
                  note: "On and Asics entered his top five inside two years. Your running grew twenty-eight percent and he does not credit you with it yet.",
                },
                {
                  v: 58,
                  note: "The ten million pairs of the Evo SL live here. The run night in Berlin graded twenty-four and read seventy-three.",
                },
              ],
            },
            {
              label: "Football",
              cells: [
                {
                  v: 78,
                  note: "Yamal, born in two thousand and seven, is the one teenage face on your record, read five times and rising. The football festival on Roblox drew fifty-one million visits in four weeks.",
                },
                {
                  v: 46,
                  note: "Women are two in five of North American football fans and the Mexico jersey was a resale hit. Your women's football plays are the kit, not yet a face of her own.",
                },
                {
                  v: 82,
                  note: "Seventy-five million Americans now call themselves soccer fans, sixteen million more than a cycle ago. The one lane where he already knows you.",
                },
                {
                  v: 72,
                  note: "The Messi film read eighty-seven and the fan zones sixty-seven and seventy-three. The World Cup year's crowd, and the median American fan is thirty-three.",
                },
              ],
            },
            {
              label: "Basketball",
              cells: [
                {
                  v: 40,
                  note: "The child's first team sport in America and the one with the most new players this year. The court defaults to a rival's shoe before the child chooses.",
                },
                {
                  v: 22,
                  note: "The women's game grew fastest among the youngest viewers this season. Your player edition sold out in an hour and your signature shoe is a man's.",
                },
                {
                  v: 38,
                  note: "The category fell a fifth in each of this year's first two quarters. The second Edwards shoe was received below the first.",
                },
                {
                  v: 30,
                  note: "The Showdown at All-Star read forty-seven and the Edwards commercial sixty. The events read, the shoe did not.",
                },
              ],
            },
            {
              label: "Apparel",
              cells: [
                {
                  v: 24,
                  note: "The kids' line is a licence, the Care Bears light-up Superstar, and it read sixty-seven. Clothing for the child has no play of its own.",
                },
                {
                  v: 36,
                  note: "Originals Sport sold out for her by your own account. Two percent of teens name your clothes.",
                },
                {
                  v: 20,
                  note: "A mall retailer is ahead of you among boys. The kit he wears is not yours.",
                },
                {
                  v: 44,
                  note: "Apparel grew nineteen percent in the quarter and was your fastest-growing brand on the resale market in the first half. The crowd buying the jersey is older than the teenager.",
                },
              ],
            },
            {
              label: "Gaming room",
              cells: [
                {
                  v: 12,
                  note: "No world of your own. The Brawl Stars skins read zero this summer while the Toy Story and Care Bears shoes read eighty and sixty-seven.",
                },
                {
                  v: 8,
                  note: "Her games are not on your record. The one in-game play that named a girl, the Toca Boca collab, is too new to read.",
                },
                {
                  v: 14,
                  note: "The football festival inside FIFA's game was his, for four weeks, before this record begins. Nothing persistent since.",
                },
                {
                  v: 10,
                  note: "The Fortnite drops of last year sold out and left no room behind. The generation that would pay for a skin has nowhere to stand.",
                },
              ],
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "Your young-facing shelf is graded in the thirties and forties and read in the sixties and eighties. The Messi film, the fan zones, the Toy Story shoes and the Berlin night all out-read their grades. The lane with no dot is the world under thirteen, and the plays that read best in every lane are a place, a person or a character the reader already loves, never the shoe alone.",
          title: "Your next-gen shelf",
          provenance: "measured",
          unit: "strength of the play · 0–100",
          note: "Every young-facing play on your record since January, by lane, on one scale. Bands are the board's range on that lane, typical to ceiling. The ring is the field's strongest play there and the dots are yours. Received is the best presence the crowd gave any play on the lane. Tap a lane for the read.",
          rows: [
            {
              id: "football",
              label: "Football",
              sub: "the fan zone, the teenage face",
              typical: 33,
              ceiling: 39,
              best: {
                brandName: "Jacquemus",
                title: "Jacquemus × Nike × FFF Les Bleus",
                pts: 51,
              },
              received: 93,
              own: [
                { title: "Lamine Yamal F50 campaign", pts: 44 },
                { title: "Home of Soccer across North America", pts: 41 },
                { title: "Messi, El Último Tango", pts: 34 },
              ],
              note: "Your most-read youth lane and the one with a teenager's face on it. The fan zones read sixty-seven and seventy-three, the Messi film eighty-seven, the Yamal film rising to sixty.",
            },
            {
              id: "womens-game",
              label: "Women's game",
              sub: "the player, the singer",
              typical: 30,
              ceiling: 34,
              best: {
                brandName: "Nike",
                title: "A'ja Wilson signature ad",
                pts: 51,
              },
              received: 67,
              own: [
                { title: "Cunningham Crazy Energy PE", pts: 36 },
                {
                  title: "Climacool campaign, De Paul and the Saballys",
                  pts: 33,
                },
                { title: "Tate McRae Climacool", pts: 30 },
                { title: "Originals Sport campaign", pts: 28 },
              ],
              note: "The McRae film read sixty-seven twice. The Originals Sport launch read zero so far, a sell-out the record has not caught up with.",
            },
            {
              id: "running-lifestyle",
              label: "Running as lifestyle",
              sub: "the collab on the running shoe",
              typical: 29,
              ceiling: 37,
              best: {
                brandName: "Red Bull",
                title: "Cyborg Season Ultra 600",
                pts: 47,
              },
              received: 80,
              own: [
                { title: "Wales Bonner SS26", pts: 44 },
                { title: "BAPE × Adizero EVO SL", pts: 40 },
                { title: "SATISFY × Adios Pro 4", pts: 39 },
              ],
              note: "The collabs read in the twenties and forties. The shoe that sold ten million pairs has no play of its own here.",
            },
            {
              id: "skate",
              label: "Skate",
              sub: "the crew, the solo shoe",
              typical: 33,
              ceiling: 41,
              best: {
                brandName: "UGG",
                title: "Palace × UGG",
                pts: 43,
              },
              received: 87,
              own: [
                { title: "Thrasher × Argentina", pts: 39 },
                { title: "Adimatic by Jamal Smith", pts: 34 },
                { title: "Temple of Skate", pts: 33 },
              ],
              note: "A crew play read sixty-seven and the solo shoe read zero. The pattern of the whole shelf.",
            },
            {
              id: "basketball",
              label: "Basketball",
              sub: "the All-Star room, the second shoe",
              typical: 34,
              ceiling: 38,
              best: {
                brandName: "Nike",
                title: "Caitlin Clark debut sneaker",
                pts: 47,
              },
              received: 80,
              own: [
                { title: "The Showdown at All-Star", pts: 44 },
                { title: "Anthony Edwards commercial", pts: 37 },
                { title: "Hellstar × AE 2", pts: 36 },
              ],
              note: "The events read and the second shoe did not. The category fell a fifth in each quarter this year.",
            },
            {
              id: "run-night",
              label: "Run night",
              sub: "the run after dark",
              typical: 29,
              ceiling: 37,
              best: {
                brandName: "Lululemon",
                title: "SeaWheeze Half Marathon",
                pts: 21,
              },
              received: 80,
              own: [{ title: "Adidas Runners City Night Berlin", pts: 24 }],
              note: "One play, graded twenty-four, read seventy-three. The widest grade-to-read gap on your record.",
            },
            {
              id: "character-family",
              label: "Character and family",
              sub: "the licence, the light-up shoe",
              typical: 36,
              ceiling: 37,
              best: {
                brandName: "Nike",
                title: "Nike × One Piece Devil Fruits tease",
                pts: 47,
              },
              received: 80,
              own: [
                { title: "Brain Dead × Disney Mickey Predator", pts: 42 },
                { title: "Toy Story × Adidas", pts: 36 },
                { title: "Care Bears × Adidas", pts: 33 },
              ],
              note: "The Toy Story shoes read eighty, the best-read character play on your board this year, and the Care Bears climbed to sixty-seven. The door to the under-thirteens is open and it is a licence.",
            },
            {
              id: "game-skins",
              label: "Game skins",
              sub: "the drop inside someone else's game",
              typical: 31,
              ceiling: 34,
              best: {
                brandName: "Uniqlo",
                title: "MapleStory snacks with in-game codes",
                pts: 29,
              },
              received: 73,
              own: [
                { title: "Sidequest Summer Streamathon", pts: 43 },
                { title: "Brawl Stars × Adidas", pts: 36 },
                { title: "Toca Boca × Adidas", pts: 33 },
                { title: "GOALS × Sidemen in-game", pts: 32 },
              ],
              note: "Five game plays this year, and the one that was read, the Brawl Stars skins, read zero. The stream and the in-game drops are not read yet. A skin is not a place.",
            },
            {
              id: "own-world",
              label: "A world of your own",
              sub: "the room under thirteen",
              typical: 31,
              ceiling: 34,
              received: 73,
              status: "recommended",
              note: "None, and no brand on your board owns one either. Your one visit to the platform where two in three users are the next generation was a four-week festival in somebody else's game, before this record begins. The band is the gaming band standing in. This is the row the second move fills.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "You are not bad at reaching the young. You are bad at reaching them with the shoe alone. The icon with a person in it, the Superstar hotel, Messi's last tango, Jennie dancing, the Toy Story shoes, read sixty-seven to ninety-three on grades in the thirties. The shoes sold straight, the Bad Bunny ballerina, the Brawl Stars skins, the five-hundred-dollar Evo, read nothing or were argued with. The next generation answers people, places and the worlds it already lives in.",
          title: "Strength against reception, the youth plays",
          provenance: "measured",
          mode: "pair",
          a: { label: "Grade", color: "#FDE047" },
          b: { label: "Reception", color: "#4ADE80" },
          note: "Fourteen plays from your own record that a teenager or a child would name. Grade is the play's measured strength, reception its best read window on the record. A tail below the line is a window that argued. Tap a row for the read.",
          rows: [
            {
              id: "hotel-superstar",
              label: "Hotel Superstar",
              sub: "the icon · a film",
              a: 35,
              b: 93,
              note: "The best-read Originals play of the year, a hotel full of the people the young already follow, and the shoe in the background.",
            },
            {
              id: "ultimo-tango",
              label: "Messi, El Último Tango",
              sub: "football · a film",
              a: 34,
              b: 87,
              note: "Read eighty-seven, sixty-seven and thirty-three across three windows. The person carried it, not the boot.",
            },
            {
              id: "toy-story",
              label: "Toy Story × Adidas",
              sub: "character · a shoe",
              a: 36,
              b: 80,
              note: "The best-read character play on your whole board this year, read three windows running. A world the child already lives in.",
            },
            {
              id: "berlin-night",
              label: "Runners City Night Berlin",
              sub: "running · a night",
              a: 24,
              b: 73,
              note: "Graded twenty-four and read seventy-three, the widest gap on your record. A run after dark, and the crowd treated it like a headline.",
            },
            {
              id: "jennie-teaser",
              label: "Jennie teaser",
              sub: "the icon · a person",
              a: 46,
              b: 67,
              note: "Read sixty-seven twice before the collection even landed. The person she follows, on the shoe she already has.",
            },
            {
              id: "care-bears",
              label: "Care Bears × Adidas",
              sub: "character · a kids' shoe",
              a: 33,
              b: 67,
              note: "Read zero, fifty-three, then sixty-seven, rising window by window. The one kids' play on your record and the crowd found it.",
            },
            {
              id: "home-of-soccer",
              label: "Home of Soccer hubs",
              sub: "football · a room",
              a: 37,
              b: 67,
              note: "A place to be during the World Cup, read sixty-seven and sixty in its first windows. The room carried the mainstream lane.",
            },
            {
              id: "mcrae-climacool",
              label: "Tate McRae Climacool",
              sub: "women's game · a face",
              a: 30,
              b: 67,
              note: "A singer and three athletes, read sixty-seven twice. The crowd arrived for the people.",
            },
            {
              id: "yamal-f50",
              label: "Lamine Yamal F50 campaign",
              sub: "football · a teenager",
              a: 44,
              b: 60,
              note: "Read five times and rising, from thirteen to sixty. The one play on your record with a teenager's name on it.",
            },
            {
              id: "stan-smith",
              label: "Stan Smith bring-back",
              sub: "the icon · the shoe straight",
              a: 30,
              b: 53,
              tail: "read −27",
              tailLow: true,
              note: "Read forty, six, minus twenty-seven and fifty-three. The icon sold straight is the one icon play the crowd argued with.",
            },
            {
              id: "bad-bunny-ballerina",
              label: "Bad Bunny ballerina",
              sub: "music · the shoe straight",
              a: 43,
              b: 0,
              tail: "read −7",
              tailLow: true,
              note: "The one Bad Bunny play argued with, and the one sold as a shoe alone. His exhibition, his apparel and his tour merch read fifty-three to seventy-three.",
            },
            {
              id: "brawl-stars",
              label: "Brawl Stars × Adidas",
              sub: "gaming · a skin",
              a: 36,
              b: 0,
              note: "Read zero in its one window. A skin in somebody else's game, with no room behind it.",
            },
            {
              id: "originals-sport-launch",
              label: "Originals Sport launch",
              sub: "apparel · the launch",
              a: 32,
              b: 0,
              note: "Read zero so far while the range sold out by your own account. The record has not caught up with her yet.",
            },
            {
              id: "evo3-limited",
              label: "Adizero Evo 3, limited",
              sub: "running · a record shoe",
              a: 68,
              b: 7,
              note: "The strongest play on this list on paper and the least read. A five-hundred-dollar shoe that won a marathon is a fact, not a room.",
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "The lanes growing fastest with the next generation are the ones you hold least. The running shoe, the women's game and the room under thirteen. The Terrace is yours and fading, football is yours and growing, and basketball is nobody's and falling. The three moves go top-left.",
          title: "Where each lane sits",
          provenance: "projected",
          x: {
            label: "How much of it you hold",
            low: "theirs",
            high: "yours",
            hint: "the lane's teen share and your record's reads, as a share of your strongest lane",
          },
          y: {
            label: "Where the lane is going",
            low: "fading",
            high: "growing",
            hint: "momentum with the next generation from this year's surveys, shelf data and reads, with fifty as flat",
          },
          quadrants: {
            tr: "Yours, growing",
            tl: "Theirs, growing",
            br: "Yours, fading",
            bl: "Nobody's yet",
          },
          note: "Eight lanes placed by how much of each you hold with the next generation and where the lane is going, an author's read of this autumn's teen survey, this year's shelf data and your record's reads. Dot size is the lane's weight in the teen wallet. The haloed dot is the room the second move builds, the hollow ones are lanes you are already in. Tap a dot for the read.",
          wLabel: "wallet",
          open: "running",
          points: [
            {
              id: "terrace",
              label: "Terrace shoe",
              era: "Yours",
              color: "#FDE047",
              x: 92,
              y: 34,
              w: 40,
              status: "current",
              note: "The lane you hold most and the one line falling on search, each spring lower than the last. Hers still, his the discounted shoe. Fading, not gone, and the chief executive says the shelf clears at the back end of next year.",
            },
            {
              id: "low-profile",
              label: "Low profile, dressy",
              era: "Yours",
              color: "#FDE047",
              x: 70,
              y: 72,
              w: 20,
              status: "current",
              note: "The Tokyo, Taekwondo and Japan in dressier versions grow strongly by your own account, and the rival's copy is already sliding. Hers, and growing. Not a lane to add a move to.",
            },
            {
              id: "football",
              label: "Football",
              era: "Yours",
              color: "#FDE047",
              x: 84,
              y: 80,
              w: 25,
              status: "current",
              note: "Yours and growing. Sixteen million new American fans in a cycle, a teenager's face on your record, and the one lane where the under-thirteens already know you. The world the second move builds stands on it.",
            },
            {
              id: "womens-game",
              label: "Women's game",
              era: "Theirs",
              color: "#FB923C",
              x: 46,
              y: 82,
              w: 18,
              status: "current",
              note: "Growing fastest among the youngest viewers, and held by a rival's signature shoes. Your player edition sold out in an hour. The night run puts her on the start line before the next survey.",
            },
            {
              id: "running",
              label: "Running shoe",
              short: "Her run, his school",
              era: "Theirs",
              color: "#FB923C",
              x: 28,
              y: 88,
              w: 30,
              status: "current",
              note: "The lane growing fastest with the next generation and the one you hold least. Four percent of upper-income girls name you, On and Asics entered his top five, and you make the shoe that sold ten million pairs. Two of the three moves land here.",
            },
            {
              id: "apparel",
              label: "Apparel",
              era: "Theirs",
              color: "#FB923C",
              x: 22,
              y: 60,
              w: 35,
              status: "current",
              note: "Two percent of teens name your clothes and a mall retailer is ahead of you among boys, while your apparel grew nineteen percent in the quarter. The biggest slice of the teen wallet and the widest gap. The school collab is the move here.",
            },
            {
              id: "basketball",
              label: "Basketball",
              era: "Nobody's",
              color: "#94A3B8",
              x: 30,
              y: 24,
              w: 15,
              status: "current",
              note: "Nobody's and falling. Your category fell a fifth in each of the first two quarters, the rival's court brand fell by the mid-teens, and the second signature shoe read below the first. The lane the moves do not price.",
            },
            {
              id: "gaming-room",
              label: "Gaming room",
              short: "Their world",
              era: "The room to build",
              color: "#22D3EE",
              x: 6,
              y: 74,
              w: 22,
              status: "recommended",
              note: "Two in three daily users of the biggest youth platform are the next generation and you have never had a room there. The Toy Story and Care Bears shoes read eighty and sixty-seven, the skins read zero. The empty lane, and the second move.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "She stays and he leaves, and the youngest have not arrived. The girl you won with the Samba is the most loyal crowd on the map and the one with no adidas running shoe. The boy went to a sport lane you are growing in without him. The under-thirteens know Yamal and not you.",
          title: "Who is leaving, who is staying",
          provenance: "projected",
          note: "Five crowds scored for how much of your next year each one carries, from this autumn's teen survey, your own quarter and the record's reads, and the clock each runs on. Tap a crowd for the drivers.",
          open: "genz-him",
          rows: [
            {
              id: "alpha",
              label: "Gen Alpha",
              context: "the room under thirteen",
              score: 42,
              role: "The unclaimed",
              horizon: "short",
              drivers: [
                "A third of the biggest youth platform's daily users are under thirteen and you own no room there",
                "UK kids ranked you fourteenth last year, up fifteen places, on their parents' Gazelles and their parents' music",
                "The Toy Story and Care Bears shoes read eighty and sixty-seven, the Brawl Stars skins zero, and the football festival drew fifty-one million visits in four weeks",
              ],
            },
            {
              id: "genz-her",
              label: "Gen Z, her",
              context: "the Terrace, hers",
              score: 84,
              role: "The Samba's crowd",
              horizon: "long",
              drivers: [
                "Fourteen percent name you, flat on the year and up from three in three years",
                "The Jane, the Mule, the Loafer and Jennie's ballet Superstar keep her on the Terrace",
                "Her running shoe is Hoka's or On's, and four percent name you",
              ],
            },
            {
              id: "genz-him",
              label: "Gen Z, him",
              context: "the sport door",
              score: 48,
              role: "Leaving by the sport door",
              horizon: "short",
              drivers: [
                "Eight percent name you, one lower, and the Terrace for him is the discounted shoe",
                "On and Asics entered his top five inside two years",
                "Your running grew twenty-eight percent and he does not credit you with it yet",
              ],
            },
            {
              id: "millennials",
              label: "Millennials",
              context: "the Evo SL, the collab",
              score: 66,
              role: "The Evo SL's buyers",
              horizon: "long",
              drivers: [
                "Ten million pairs of a hundred-and-fifty-dollar running shoe in a year",
                "The run night in Berlin graded twenty-four and read seventy-three",
                "Still the generation that reads your collabs",
              ],
            },
            {
              id: "genx",
              label: "Gen X",
              context: "the parents' wallet",
              score: 30,
              role: "The parents' wallet",
              horizon: "long",
              drivers: [
                "Shoe prices up five percent on the year, the fastest rise in nearly four years, and the extra pair is theirs to refuse",
                "Children's shoes up two percent",
              ],
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three moves, each in a lane the map shows growing and you holding least. Her run, his school, their world. None is a new shoe. All three put a place or a name around a shoe you already make.",
          title: "Three moves, priced",
          provenance: "projected",
          plays: [
            {
              name: "Originals Sport Night Run, a girls'-first run night under the Originals Sport name in Los Angeles, London and Sydney, the Evo SL on every starter, the McRae cast on the start line and a ballot for the place",
              itemType: "experience",
              window:
                "Spring 2027, the first three nights before the autumn teen survey",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "scarcity", fit: 0.5 },
              ],
              why: "She is your crowd and she buys her running shoe elsewhere. The lane where the next generation is growing fastest and names you least is a running lane, and fandom, the crowd that comes back, is the strategy your rooms are read best on and the one you bring least.",
              effect: {
                label: "CIQ",
                delta: 0.9,
                series: [0, 0.3, 0.6, 0.8, 0.9],
              },
              precedents: 3,
              reception:
                "your Berlin run night graded 24 and read 73, the women's Climacool film read 67 twice, and a rival's women's race series drew fifty thousand in its first year",
              similar: [
                {
                  brand: "lululemon",
                  brandName: "Lululemon",
                  title: "SeaWheeze Half Marathon and Sunset Festival",
                  pts: 20.7,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "A'ja Wilson signature ad",
                  pts: 50.7,
                },
              ],
            },
            {
              name: "Home of Soccer, the world, a persistent Adidas-owned Roblox world: Yamal's F50 on the avatar, the Trionda, the fourteen partner clubs and a drop every matchweek",
              itemType: "experience",
              window:
                "Open by spring 2027, a drop every matchweek through the season",
              strategies: [
                { code: "identity_signal", fit: 0.7 },
                { code: "fandom", fit: 0.6 },
              ],
              why: "Two in three daily users of the biggest youth platform are the next generation and you have never had a room there. Football is the lane the under-thirteens already know you in, and the one with a teenager's face on your record. Identity, the sign you are seen in, is what an avatar wears.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.25, 0.5, 0.7, 0.8],
              },
              precedents: 3,
              reception:
                "your four-week festival inside FIFA's game drew 51 million visits, your Toy Story and Care Bears shoes read 80 and 67 while the Brawl Stars skins read 0, and the one brand world with current figures has 132 million visits and half its players under thirteen",
              similar: [
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "Nike × One Piece Devil Fruits tease",
                  pts: 47.0,
                },
                {
                  brand: "uniqlo",
                  brandName: "Uniqlo",
                  title: "Retro Pokémon Returns to Uniqlo",
                  pts: 34.0,
                },
              ],
            },
            {
              name: "Evo SL Varsity, the ten-million-pair running shoe in school colours, a collab with the hundred and nine Adidas schools, the Penn State and Tennessee classes first, the athletes paid through the programme, sold on campus and at the state cross-country meets",
              itemType: "collab",
              window: "Back to school 2027, the first two schools in August",
              strategies: [
                { code: "identity_signal", fit: 0.7 },
                { code: "aesthetic_innovation", fit: 0.5 },
              ],
              why: "He left the Terrace for a running shoe and named On and Asics. You make the running shoe that sold ten million pairs and he does not credit you with it. The school is where he is told what to wear, and the crest is the identity signal he already carries.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.2, 0.4, 0.55, 0.6],
              },
              precedents: 3,
              reception:
                "your BAPE Evo SL collab read 46, 40 and 40, the five-hundred-dollar Evo 3 read 7, and a federation collab on the board read 73",
              similar: [
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "Naomi Osaka's French Open Nike x Germanier debut",
                  pts: 56.2,
                },
                {
                  brand: "gap",
                  brandName: "Gap",
                  title: "Gap × Malbon",
                  pts: 35.4,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on your measured record and the public facts in the file header, and compound with your current course. The teen survey behind the frame is one American read a year, and the moves are priced on your record, not on it.",
        },
        {
          kind: "impact",
          title: "What the three moves carry",
          provenance: "projected",
          delta: 2.3,
          body: "About two and a third points on your published score, from 85.32 to roughly 87.6, past the leader on the board. The comparison that matters is the one your shelf already made. The plays with a person or a room in them read twenty points above the plays that sold a shoe straight. The qualifier is the teen survey, one American read a year. The moves are priced on your record, not on it.",
        },
        {
          kind: "modelView",
          body: "The girl is yours and the boy is not, and that is the real finding under the noise. The tell is that the two brands he named this year did not exist on his list two years ago, and both of them make running shoes. He did not leave you for another Terrace. He left the Terrace for a sport, and you are growing in that sport without him. The youngest have not arrived at all, because there is no room of yours for them to stand in, only a licence on a shoe and a four-week visit to somebody else's game.\n\nWhat can be read at your scale is the lane and not the point. One American survey a year cannot read a one-point move, and your measured record sits flat at its ceiling because it measures the plays you make, not the aisles a teenager shops. The loss is in lanes the record has not been asked about yet, which is why the score has not moved while the survey has. What the record does read is the shape. The plays with a person, a place or a character in them are read far above their grade, and the shoes sold straight are read at nothing or argued with.\n\nSo build rooms around the shoes you already make. Her run, his school, their world. Do not call any of it a youth strategy, because naming the young is the one thing on your record that does not read. And do not chase the next Samba. The rival who did is in its sixth quarter of decline.",
        },
      ],
    },
    {
      id: "communities-next",
      // which crowds could carry what the brand means after the terrace.
      // An identity question on the community type; the lead move is a room
      itemType: "community",
      type: "community",
      question: "Which communities could redefine what adidas stands for next?",
      aliases: [
        "which communities will decide what adidas means next",
        "who could own the adidas story after the terrace era",
        "which communities could redefine adidas",
        "which communities will define adidas next",
        "what will adidas stand for next",
        "who will decide what adidas means next",
        "which crowds could redefine our brand",
        "what comes after the terrace for adidas",
        "which communities should adidas build next",
        "who is the next adidas community",
      ],
      askedOn: "2026-11-02",
      blocks: [
        {
          kind: "readout",
          provenance: "measured",
          verdict:
            "Your record still calls your community the terrace and the sneakerhead, and that chapter is the one cooling. The next one already reads you warmest: women who play and dance, the Asian fan, and the Latin crowd when it makes the kit itself.",
        },
        {
          kind: "stats",
          provenance: "observed",
          insight:
            "Your growth already carries new crowds' names. Mexico's shirt sold best at the World Cup, Latin America and Japan and Korea are your fastest regions, and the clothing grows while the terrace shoe that defined the last chapter has turned negative. The communities paying for the brand are not the ones your record describes.",
          items: [
            {
              label: "Mexico's World Cup shirt",
              value: "#1",
              hint: "the best-selling jersey of this summer's World Cup, ahead of Argentina, in a tournament where you sold four times the jerseys of the last one. Your biggest new crowd speaks Spanish",
            },
            {
              label: "Latin America, spring",
              value: "+28%",
              hint: "your sales growth in Latin America in the spring quarter, after twenty-six in the winter, your fastest region. The crowd that bought the shirt is buying the brand",
            },
            {
              label: "Japan and Korea, spring",
              value: "+18%",
              hint: "your growth in Japan and South Korea in the spring quarter, after twenty-three in the winter, with Greater China up thirteen this autumn. Jennie's square-toe Superstar is the shoe your chief executive says is flying",
            },
            {
              label: "Originals apparel, autumn",
              value: "~50%",
              hint: "growth of Originals clothing this autumn by your chief executive's account, while Originals footwear is negative. The terrace shoe is the part of the house that stopped",
            },
          ],
        },
        {
          kind: "shift",
          insight:
            "The new crowds want a room, a team and a hand in the making. Young adults are lonely and find company in a studio sooner than a bar, the women's game is the fastest-growing crowd in sport, and the next football fan in America speaks Spanish. The last row is the lesson. A community you borrow from turns on you.",
          title: "What the new crowds are doing",
          provenance: "observed",
          note: "Six public numbers from the past year. Each line says what the figure counts and why it is here. The last one is the risk, not a signal.",
          rows: [
            {
              label: "Lonely at the weekend",
              context:
                "Share of Americans aged eighteen to twenty-nine who say they feel lonely at the weekend this spring, thirty-seven points above the boomers. Two in three of them feel closer to people in a wellness setting than on a night out, so the room a brand hosts is part of what it sells.",
              value: "51%",
            },
            {
              label: "Women's elite sport revenue",
              context:
                "What women's elite sport is set to earn worldwide this year, a quarter more than last year, with basketball and football each about a third of it. The women's game is the fastest-growing crowd in sport, and you dress its newest league from next season.",
              value: "$3bn",
            },
            {
              label: "Pilates, the past year",
              context:
                "Growth in the number of Americans doing Pilates in the twelve months to June, against one percent for running. The studio is where she trains now, and your record holds nine plays in it.",
              value: "+10.9%",
            },
            {
              label: "Hispanic adults following the Cup",
              context:
                "Share of Hispanic American adults who said this spring they were likely to follow the World Cup, against twenty-eight percent of all adults. The next football fan in your biggest market speaks Spanish first.",
              value: "42%",
            },
            {
              label: "#balletcore against #blokecore",
              context:
                "TikTok views on the ballet look's tag against the terrace look's, about a billion to under half a billion, as read this week. The feed already dresses the dancer more than the casual.",
              value: "2 to 1",
            },
            {
              label: "The Oaxaca slip-on",
              context:
                "The slip-on drawn from a Zapotec town's sandal was withdrawn after you apologised before its assembly in August last year, and a year on the terms of the repair are still not public. The Latin lane carries that memory, and the crowd will look for the maker's name next time.",
              value: "Withdrawn",
            },
          ],
        },
        {
          kind: "trendCompare",
          insight:
            "The terrace look is flat on search for three years while three new names climb. Your Taekwondo, the ballet sneaker, searches five times what it did two years ago and is the biggest community line on the chart. Willy Chavarria rose five times, and Jennie's name beside yours went from nothing to two thirds of the chart's peak in the two months of her collection. The Taekwondo has halved since its spring peak, so the dancer is a crowd to build, not a shoe to ride.",
          title: "Where the search went",
          provenance: "observed",
          note: "Worldwide Google search interest for five terms, monthly means from January 2024 to October 2026 on one scale. The busiest month of any of them reads 100. blokecore is the terrace look's own word. balletcore, the ghost, is the ballet look's word, the trend the feed names that search barely confirms.",
          highlight: {
            from: "2026-08-01",
            to: "2026-09-30",
            label: "Jennie's collection",
          },
          series: [
            {
              key: "taekwondo",
              label: "Adidas Taekwondo",
              color: "#FF7AB8",
              points: [
                { d: "2024-01-01", v: 6 },
                { d: "2024-02-01", v: 6 },
                { d: "2024-03-01", v: 5 },
                { d: "2024-04-01", v: 6 },
                { d: "2024-05-01", v: 6 },
                { d: "2024-06-01", v: 9 },
                { d: "2024-07-01", v: 11 },
                { d: "2024-08-01", v: 15 },
                { d: "2024-09-01", v: 19 },
                { d: "2024-10-01", v: 19 },
                { d: "2024-11-01", v: 20 },
                { d: "2024-12-01", v: 28 },
                { d: "2025-01-01", v: 35 },
                { d: "2025-02-01", v: 40 },
                { d: "2025-03-01", v: 75 },
                { d: "2025-04-01", v: 68 },
                { d: "2025-05-01", v: 61 },
                { d: "2025-06-01", v: 60 },
                { d: "2025-07-01", v: 71 },
                { d: "2025-08-01", v: 74 },
                { d: "2025-09-01", v: 53 },
                { d: "2025-10-01", v: 51 },
                { d: "2025-11-01", v: 48 },
                { d: "2025-12-01", v: 50 },
                { d: "2026-01-01", v: 45 },
                { d: "2026-02-01", v: 46 },
                { d: "2026-03-01", v: 72 },
                { d: "2026-04-01", v: 98 },
                { d: "2026-05-01", v: 100 },
                { d: "2026-06-01", v: 88 },
                { d: "2026-07-01", v: 80 },
                { d: "2026-08-01", v: 76 },
                { d: "2026-09-01", v: 58 },
                { d: "2026-10-01", v: 44 },
              ],
            },
            {
              key: "chavarria",
              label: "Willy Chavarria",
              color: "#FB923C",
              points: [
                { d: "2024-01-01", v: 3 },
                { d: "2024-02-01", v: 6 },
                { d: "2024-03-01", v: 2 },
                { d: "2024-04-01", v: 3 },
                { d: "2024-05-01", v: 4 },
                { d: "2024-06-01", v: 5 },
                { d: "2024-07-01", v: 6 },
                { d: "2024-08-01", v: 7 },
                { d: "2024-09-01", v: 11 },
                { d: "2024-10-01", v: 9 },
                { d: "2024-11-01", v: 6 },
                { d: "2024-12-01", v: 6 },
                { d: "2025-01-01", v: 32 },
                { d: "2025-02-01", v: 17 },
                { d: "2025-03-01", v: 8 },
                { d: "2025-04-01", v: 10 },
                { d: "2025-05-01", v: 24 },
                { d: "2025-06-01", v: 22 },
                { d: "2025-07-01", v: 17 },
                { d: "2025-08-01", v: 27 },
                { d: "2025-09-01", v: 12 },
                { d: "2025-10-01", v: 11 },
                { d: "2025-11-01", v: 12 },
                { d: "2025-12-01", v: 17 },
                { d: "2026-01-01", v: 27 },
                { d: "2026-02-01", v: 26 },
                { d: "2026-03-01", v: 52 },
                { d: "2026-04-01", v: 44 },
                { d: "2026-05-01", v: 34 },
                { d: "2026-06-01", v: 49 },
                { d: "2026-07-01", v: 28 },
                { d: "2026-08-01", v: 28 },
                { d: "2026-09-01", v: 27 },
                { d: "2026-10-01", v: 26 },
              ],
            },
            {
              key: "jennie",
              label: "Jennie × Adidas",
              color: "#60A5FA",
              points: [
                { d: "2024-01-01", v: 2 },
                { d: "2024-02-01", v: 2 },
                { d: "2024-03-01", v: 2 },
                { d: "2024-04-01", v: 2 },
                { d: "2024-05-01", v: 2 },
                { d: "2024-06-01", v: 5 },
                { d: "2024-07-01", v: 3 },
                { d: "2024-08-01", v: 2 },
                { d: "2024-09-01", v: 2 },
                { d: "2024-10-01", v: 3 },
                { d: "2024-11-01", v: 2 },
                { d: "2024-12-01", v: 1 },
                { d: "2025-01-01", v: 2 },
                { d: "2025-02-01", v: 2 },
                { d: "2025-03-01", v: 2 },
                { d: "2025-04-01", v: 2 },
                { d: "2025-05-01", v: 2 },
                { d: "2025-06-01", v: 2 },
                { d: "2025-07-01", v: 5 },
                { d: "2025-08-01", v: 8 },
                { d: "2025-09-01", v: 8 },
                { d: "2025-10-01", v: 6 },
                { d: "2025-11-01", v: 4 },
                { d: "2025-12-01", v: 3 },
                { d: "2026-01-01", v: 3 },
                { d: "2026-02-01", v: 3 },
                { d: "2026-03-01", v: 9 },
                { d: "2026-04-01", v: 8 },
                { d: "2026-05-01", v: 5 },
                { d: "2026-06-01", v: 4 },
                { d: "2026-07-01", v: 4 },
                { d: "2026-08-01", v: 65 },
                { d: "2026-09-01", v: 65 },
                { d: "2026-10-01", v: 24 },
              ],
            },
            {
              key: "blokecore",
              label: "blokecore",
              color: "#FDE047",
              points: [
                { d: "2024-01-01", v: 4 },
                { d: "2024-02-01", v: 6 },
                { d: "2024-03-01", v: 5 },
                { d: "2024-04-01", v: 5 },
                { d: "2024-05-01", v: 5 },
                { d: "2024-06-01", v: 8 },
                { d: "2024-07-01", v: 6 },
                { d: "2024-08-01", v: 6 },
                { d: "2024-09-01", v: 4 },
                { d: "2024-10-01", v: 4 },
                { d: "2024-11-01", v: 3 },
                { d: "2024-12-01", v: 3 },
                { d: "2025-01-01", v: 2 },
                { d: "2025-02-01", v: 2 },
                { d: "2025-03-01", v: 3 },
                { d: "2025-04-01", v: 3 },
                { d: "2025-05-01", v: 2 },
                { d: "2025-06-01", v: 3 },
                { d: "2025-07-01", v: 4 },
                { d: "2025-08-01", v: 4 },
                { d: "2025-09-01", v: 6 },
                { d: "2025-10-01", v: 7 },
                { d: "2025-11-01", v: 9 },
                { d: "2025-12-01", v: 6 },
                { d: "2026-01-01", v: 4 },
                { d: "2026-02-01", v: 5 },
                { d: "2026-03-01", v: 4 },
                { d: "2026-04-01", v: 3 },
                { d: "2026-05-01", v: 5 },
                { d: "2026-06-01", v: 8 },
                { d: "2026-07-01", v: 8 },
                { d: "2026-08-01", v: 4 },
                { d: "2026-09-01", v: 3 },
                { d: "2026-10-01", v: 2 },
              ],
            },
            {
              key: "balletcore",
              label: "balletcore",
              color: "#A78BFA",
              ghost: true,
              points: [
                { d: "2024-01-01", v: 5 },
                { d: "2024-02-01", v: 6 },
                { d: "2024-03-01", v: 4 },
                { d: "2024-04-01", v: 4 },
                { d: "2024-05-01", v: 3 },
                { d: "2024-06-01", v: 3 },
                { d: "2024-07-01", v: 4 },
                { d: "2024-08-01", v: 3 },
                { d: "2024-09-01", v: 2 },
                { d: "2024-10-01", v: 3 },
                { d: "2024-11-01", v: 3 },
                { d: "2024-12-01", v: 3 },
                { d: "2025-01-01", v: 2 },
                { d: "2025-02-01", v: 2 },
                { d: "2025-03-01", v: 3 },
                { d: "2025-04-01", v: 3 },
                { d: "2025-05-01", v: 3 },
                { d: "2025-06-01", v: 3 },
                { d: "2025-07-01", v: 4 },
                { d: "2025-08-01", v: 4 },
                { d: "2025-09-01", v: 3 },
                { d: "2025-10-01", v: 3 },
                { d: "2025-11-01", v: 3 },
                { d: "2025-12-01", v: 2 },
                { d: "2026-01-01", v: 4 },
                { d: "2026-02-01", v: 7 },
                { d: "2026-03-01", v: 7 },
                { d: "2026-04-01", v: 7 },
                { d: "2026-05-01", v: 10 },
                { d: "2026-06-01", v: 8 },
                { d: "2026-07-01", v: 11 },
                { d: "2026-08-01", v: 4 },
                { d: "2026-09-01", v: 6 },
                { d: "2026-10-01", v: 4 },
              ],
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "Your record scores your community higher every time and describes the same one each time. The terrace, the casual, the sneakerhead and the members' app are named in all three reads. The Latin crowd, the Asian fan and the women who play and dance are named in none, though each of them reads you warmer than the terrace does.",
          title: "What the record calls your community",
          provenance: "measured",
          note: "The three community assessments on your record this year, with the score each gave. A lit cell is a crowd the assessment names, a dark one a crowd it leaves out. Tap a cell for the read.",
          cols: [
            "Terrace",
            "Sneakerheads",
            "Members' app",
            "Latin",
            "Asian fans",
            "Women & dance",
          ],
          rows: [
            {
              label: "January, 74.5",
              cells: [
                {
                  v: 100,
                  note: "Named first. The community is anchored in football terrace culture, hip-hop and streetwear.",
                },
                {
                  v: 100,
                  note: "Named through hip-hop, streetwear and the drops on the Confirmed app.",
                },
                {
                  v: 100,
                  note: "adiClub and the Confirmed app, the members' door.",
                },
                {
                  v: 0,
                  note: "Not named, in the week your Chavarria runway showed in Paris.",
                },
                {
                  v: 0,
                  note: "Not named, a fortnight before the Seoul pop-ups.",
                },
                {
                  v: 0,
                  note: "Not named, eleven days after the ballet flat reached the record.",
                },
              ],
            },
            {
              label: "May, 75.3",
              cells: [
                {
                  v: 100,
                  note: "Named again as terrace fashion, a subculture that organises itself.",
                },
                {
                  v: 100,
                  note: "Named as sneaker collecting.",
                },
                {
                  v: 100,
                  note: "adiClub, with the Adidas Runners network beside it.",
                },
                {
                  v: 0,
                  note: "Not named, three months after the Super Bowl shoe.",
                },
                {
                  v: 0,
                  note: "Not named, two months after the Felix and Jung Ho-yeon campaign.",
                },
                {
                  v: 0,
                  note: "Not named, with the ballet flat still argued with.",
                },
              ],
            },
            {
              label: "August, 78.2",
              cells: [
                {
                  v: 100,
                  note: "Named as the UK casuals, carried by the Samba, the Gazelle and the Spezial.",
                },
                {
                  v: 100,
                  note: "Named as the global sneakerheads.",
                },
                {
                  v: 100,
                  note: "adiClub and the Confirmed app again.",
                },
                {
                  v: 0,
                  note: "Not named, the summer your Mexico shirt sold best at the World Cup.",
                },
                {
                  v: 0,
                  note: "Not named, a week before Jennie's teaser.",
                },
                {
                  v: 0,
                  note: "Not named, while your women's plays read warmer than any other lane.",
                },
              ],
            },
          ],
        },
        {
          kind: "arena",
          insight:
            "Your community plays are graded in the thirties and forties, and the crowds that read them warmest sit in the lanes you play least. The Latin lane holds your strongest grades, and a rival now holds its designer. The dance lane is the board's lowest band with your ballet flat above it. The one lane with no dot is a lane you have never entered.",
          title: "Your community lanes",
          provenance: "measured",
          unit: "strength of the play · 0–100",
          note: "Every community play on your record since January, by lane, on one scale. Bands are the board's range on that lane, typical to ceiling. The ring is the field's strongest play there and the dots are yours. Received is the best presence the crowd gave any play on the lane. The tinted lanes are where the moves build. Tap a lane for the read.",
          rows: [
            {
              id: "supporters",
              label: "Football supporters",
              sub: "the terrace, the casual",
              typical: 30,
              ceiling: 35,
              best: {
                brandName: "Nike",
                title: "Nike Ignites Football Fandom in stores",
                pts: 29,
              },
              received: 87,
              own: [
                { title: "Man United × Stone Roses", pts: 37 },
                { title: "City Series Torino", pts: 33 },
                { title: "Originals Football Culture collection", pts: 27 },
              ],
              note: "Your busiest lane, thirty-four plays, and the coolest read of any lane you play often. The Football Culture collection read eighty-seven, then forty-seven, forty and zero.",
            },
            {
              id: "latin",
              label: "Latin & Chicano",
              sub: "Mexico, Puerto Rico, the diaspora",
              typical: 38,
              ceiling: 43,
              best: {
                brandName: "UGG",
                title: "UGG × Willy Chavarria, UGG & KISSES",
                pts: 48,
              },
              received: 87,
              own: [
                { title: "Chavarria Fall 2027 runway, Paris", pts: 50 },
                { title: "Chavarria, Love Prevails", pts: 50 },
                { title: "Bad Bunny BadBo 1.0 debut", pts: 48 },
                { title: "Someone Somewhere, Mexico", pts: 45 },
              ],
              status: "recommended",
              note: "Your strongest grades, twenty-eight plays read plus thirty-two. Zara, Nike and UGG read warmer on fewer, and the designer who led your lane debuted with UGG at eighty.",
            },
            {
              id: "asian-fans",
              label: "K-pop & Asian fans",
              sub: "the fan club, Seoul, Tokyo",
              typical: 35,
              ceiling: 40,
              best: {
                brandName: "Uniqlo",
                title: "Uniqlo UT × G-Dragon's ZO&FRIENDS",
                pts: 33,
              },
              received: 93,
              own: [
                { title: "Originals by JENNIE teaser", pts: 46 },
                { title: "Ado's Japan jersey", pts: 41 },
                { title: "Seochon pop-up events", pts: 32 },
                { title: "Urban Street, Felix and Jung Ho-yeon", pts: 29 },
              ],
              status: "recommended",
              note: "Eight plays read plus fifty-one and the best single read on the topic, ninety-three. The Jennie teaser read sixty-seven. A star on Japan's shirt was argued with.",
            },
            {
              id: "womens",
              label: "Women's game",
              sub: "the court, the pitch",
              typical: 32,
              ceiling: 35,
              best: {
                brandName: "Nike",
                title: "A'ja Wilson signature ad",
                pts: 51,
              },
              received: 67,
              own: [
                {
                  title: "Climacool, De Paul and the Saballys",
                  pts: 33,
                },
                { title: "Tate McRae Climacool", pts: 30 },
                { title: "Copper × Ryoko Rain", pts: 27 },
              ],
              note: "The warmest lane on your record, plus fifty-nine, on seven plays graded lowest of all. Only Nike plays it beside you.",
            },
            {
              id: "dance",
              label: "Dance & studio",
              sub: "the class, the stage",
              typical: 25,
              ceiling: 35,
              best: {
                brandName: "Nike",
                title: "Dance of Champions with Sabalenka",
                pts: 28,
              },
              received: 80,
              own: [
                { title: "Taekwondo Mei Ballet Flat", pts: 38 },
                { title: "Taekwondo Mei Ballet Leopard", pts: 23 },
                { title: "BANDALOOP vertical dance", pts: 22 },
              ],
              status: "recommended",
              note: "The board's lowest band. Lululemon plays it most and reads cooler. Your ballet flat was argued with in spring and climbed to seventy-three.",
            },
            {
              id: "diaspora",
              label: "Black British design",
              sub: "Wales Bonner, the runway",
              typical: 42,
              ceiling: 45,
              received: 60,
              own: [
                { title: "Wales Bonner × Y-3 Field Lizzard", pts: 45 },
                { title: "Wales Bonner SS26", pts: 44 },
                { title: "Grace Wales Bonner × Y-3 SS26 runway", pts: 40 },
              ],
              note: "The board's highest band, and your plays sit in it, read from twenty-six to fifty-three. Six plays, and the designer leads a luxury house's menswear from January.",
            },
            {
              id: "skate",
              label: "Skate",
              sub: "the park, the crew",
              typical: 33,
              ceiling: 40,
              best: {
                brandName: "Nike",
                title: "Nike SB × Rukus × Mary Lee Donuts Dunk",
                pts: 43,
              },
              received: 87,
              own: [
                { title: "Thrasher × Argentina", pts: 39 },
                { title: "Adimatic by Jamal Smith", pts: 34 },
                { title: "Temple of Skate", pts: 33 },
              ],
              note: "Seven plays read plus twenty-seven. Nike reads the skater warmer, plus forty-three, on eight.",
            },
            {
              id: "pride",
              label: "Queer & pride",
              sub: "the crowd you have not met",
              typical: 22,
              ceiling: 27,
              best: {
                brandName: "Lululemon",
                title: "Lululemon Pride collection",
                pts: 22,
              },
              received: 67,
              note: "The one lane on the board you have never played. Four plays from two brands, read mixed. A lane to earn with a partner from inside it, never a logo for one month.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "You spend your plays on the community that made you, and the ones you barely court read you best. The supporters' lane carries thirty-four plays and the coolest read of any lane you play often. The women's game and the Asian fan carry fifteen plays between them and the warmest reads on the record. The next chapter is already reading you, and you are not yet talking to it.",
          title: "Plays against reads, lane by lane",
          provenance: "measured",
          mode: "pair",
          a: { label: "Plays", color: "#FDE047" },
          b: { label: "Read", color: "#4ADE80" },
          note: "Your community plays since January, lane by lane. Plays is the count, read is the crowd's average net reception across every window it read them. Tap a row for the read.",
          rows: [
            {
              id: "supporters",
              label: "Football supporters",
              sub: "the terrace",
              a: 34,
              b: 22,
              note: "Twenty-two plays read, plus twenty-two on average. The most played and the coolest of your big lanes.",
            },
            {
              id: "latin",
              label: "Latin & Chicano",
              sub: "Mexico, Puerto Rico",
              a: 28,
              b: 32,
              note: "Twenty-four read, plus thirty-two, with the highest grades of any lane. The crowd is there and the read is middling.",
            },
            {
              id: "sneakerheads",
              label: "Sneakerheads",
              sub: "the boutique, the raffle",
              a: 22,
              b: 26,
              note: "Eighteen read, plus twenty-six. The collector still answers and answers cooler than the new crowds.",
            },
            {
              id: "club",
              label: "Club & music nights",
              sub: "Berlin, the DJ booth",
              a: 14,
              b: 39,
              note: "Eight read, plus thirty-nine. The Berlin night read seventy-three.",
            },
            {
              id: "dance",
              label: "Dance & studio",
              sub: "the class",
              a: 9,
              b: 36,
              note: "Four read, plus thirty-six, and the ballet flat climbing.",
            },
            {
              id: "asian-fans",
              label: "K-pop & Asian fans",
              sub: "the fan club",
              a: 8,
              b: 51,
              note: "Five read, plus fifty-one, with the best single read on the topic.",
            },
            {
              id: "womens",
              label: "Women's game",
              sub: "the court",
              a: 7,
              b: 59,
              note: "Three read, plus fifty-nine, the warmest lane on your record.",
            },
            {
              id: "skate",
              label: "Skate",
              sub: "the park",
              a: 7,
              b: 27,
              note: "Seven read, plus twenty-seven.",
            },
          ],
        },
        {
          kind: "pairs",
          insight:
            "The plays a community makes or wears its own way read far above their grade. A Mexican maker's World Cup collection read eighty, and the dancer's flat climbed to seventy-three. The plays aimed at a crowd from outside read nothing or were argued with: the red ballerina, the borrowed cowboys, a star on Japan's shirt. Make it with them, not at them.",
          title: "Made with them, made at them",
          provenance: "measured",
          mode: "pair",
          a: { label: "Grade", color: "#FDE047" },
          b: { label: "Reception", color: "#4ADE80" },
          note: "Ten community plays from your record. Grade is the play's measured strength, reception its best read window. A tail closes a row whose reads turned or argued. Tap a row for the read.",
          rows: [
            {
              id: "someone-somewhere",
              label: "Someone Somewhere, Mexico",
              sub: "made with makers · a collection",
              a: 45,
              b: 80,
              note: "A Mexican maker's collection for the World Cup, read eighty in its first window. The best-read Latin play of the year.",
            },
            {
              id: "ballet-flat",
              label: "Taekwondo Mei Ballet Flat",
              sub: "the dancer's shoe",
              a: 38,
              b: 80,
              note: "Read eight times. The crowd argued with it in spring at minus twenty and read it at seventy-three by summer. It changed its mind.",
            },
            {
              id: "badbo",
              label: "BadBo 1.0 debut",
              sub: "his shoe on his stage",
              a: 48,
              b: 73,
              note: "Bad Bunny's own shoe at his halftime show, read seventy-three in its first window and cooling across six.",
            },
            {
              id: "artisans-kit",
              label: "Mexico's women artisans kit",
              sub: "made with makers · a kit",
              a: 44,
              b: 67,
              note: "A third kit that carried its makers' names, read sixty in its one warm window.",
            },
            {
              id: "love-prevails",
              label: "Chavarria, Love Prevails",
              sub: "a designer from the crowd",
              a: 50,
              b: 67,
              note: "Read sixty-seven, with fandom among its strategies.",
            },
            {
              id: "jennie",
              label: "Originals by JENNIE teaser",
              sub: "her fans · a film",
              a: 46,
              b: 67,
              note: "Read sixty-seven in its first window. The collection itself landed after the record's window.",
            },
            {
              id: "football-culture",
              label: "Football Culture collection",
              sub: "the terrace · a collection",
              a: 27,
              b: 87,
              tail: "to 0",
              tailLow: true,
              note: "Read eighty-seven, forty-seven, forty, then zero, window by window. The terrace still answers, and less each time.",
            },
            {
              id: "ballerina",
              label: "Bad Bunny red ballerina",
              sub: "a shoe aimed at the fans",
              a: 43,
              b: 20,
              tail: "−7",
              tailLow: true,
              note: "Graded forty-three, read at minus seven. The same artist's shoe on his own stage read seventy-three.",
            },
            {
              id: "ado",
              label: "Ado's Japan jersey",
              sub: "a star on a national shirt",
              a: 41,
              b: 0,
              tail: "−27",
              tailLow: true,
              note: "Graded forty-one, and the crowd argued with it at minus twenty-seven in its one window.",
            },
            {
              id: "compton",
              label: "Chavarria × Compton Cowboys",
              sub: "a borrowed crew",
              a: 38,
              b: 0,
              note: "Read once, at zero. Nobody argued and nobody took it up.",
            },
          ],
        },
        {
          kind: "quadrant",
          insight:
            "Fandom, the crowd that comes back, is the strategy a community answers best and the one you bring least. Ten of your community plays carry it, and they read warmest of all. Identity, the sign worn to say who you are, carries fifty and reads just under your average. The moves are built on the crowd returning, not on the sign.",
          title: "Which strategy a community answers",
          provenance: "measured",
          x: {
            label: "How often you play it",
            low: "rare",
            high: "often",
            hint: "community plays carrying the strategy, as a share of identity's fifty",
          },
          y: {
            label: "How the crowd reads it",
            low: "cooler",
            high: "warmer",
            hint: "average reception, with fifty as your community plays' average and each point of reception five steps",
          },
          quadrants: {
            tr: "Played and read",
            tl: "Read, rarely played",
            br: "Played, read less",
            bl: "Rare and cool",
          },
          note: "The five strategies on your community plays since January, placed by how often you play each and how the crowd reads it. Dot size is the number of plays. The haloed dot is the strategy the three moves are built on. Tap a dot for the read.",
          wLabel: "plays",
          open: "fandom",
          points: [
            {
              id: "identity",
              label: "Identity signal",
              color: "#FDE047",
              x: 97,
              y: 44,
              w: 50,
              status: "current",
              note: "Identity signal, the sign a crowd wears to say who it is. Fifty community plays, reception thirty-nine. Your default, and read well.",
            },
            {
              id: "aesthetic",
              label: "Aesthetic innovation",
              color: "#FB923C",
              x: 82,
              y: 52,
              w: 41,
              status: "current",
              note: "Aesthetic innovation, the new look. Forty-one plays, reception forty.",
            },
            {
              id: "fandom",
              label: "Fandom",
              short: "the moves",
              color: "#FF7AB8",
              x: 20,
              y: 84,
              w: 10,
              status: "recommended",
              note: "Fandom, the crowd that comes back. Ten plays and the best reception on a community play, forty-seven. The strategy a community wants and the one you bring least.",
            },
            {
              id: "scarcity",
              label: "Scarcity",
              color: "#60A5FA",
              x: 8,
              y: 59,
              w: 4,
              note: "Scarcity, the drop you have to be there for. Four plays, reception forty-two. Too few to read as a habit.",
            },
            {
              id: "opacity",
              label: "Opacity",
              color: "#B388FF",
              x: 6,
              y: 17,
              w: 3,
              note: "Opacity, the strategy of withholding. Three plays, reception thirty-three, the coolest of the five.",
            },
          ],
        },
        {
          kind: "cohorts",
          insight:
            "Three crowds could carry what you mean next, and one is the chapter closing. Women who play and dance read you warmest and are the fastest-growing crowd in sport. The Asian fan is paying for your growth. The Latin crowd is your biggest new one and the most contested. The terrace still pays the bills and reads you coolest.",
          title: "The crowds that could carry it",
          provenance: "projected",
          note: "Five crowds scored for how much of your next chapter each one could carry, from the record's reads, your own quarters and this year's public data, and the clock each runs on. Tap a crowd for the drivers.",
          open: "women",
          rows: [
            {
              id: "women",
              label: "Women who play and dance",
              context: "the court, the studio, the stage",
              score: 86,
              role: "The next definition",
              horizon: "long",
              drivers: [
                "Your women's plays read plus fifty-nine, the warmest lane on your record",
                "Women's elite sport earns a quarter more this year, and you dress a new women's league from next season",
                "Pilates grew eleven percent in a year while running grew one",
                "Fourteen percent of teen girls name you their favourite shoe, the one crowd that names you more than the boys do",
              ],
            },
            {
              id: "asian",
              label: "The Asian fan",
              context: "Seoul, Tokyo, Shanghai, the fan club",
              score: 82,
              role: "The warmest read",
              horizon: "short",
              drivers: [
                "The K-pop and Asian lane reads plus fifty-one, with the best single read on the topic",
                "Japan and Korea grew eighteen percent in the spring and Greater China thirteen this autumn",
                "Jennie moved from face to co-designer, and her square-toe Superstar is flying by your chief executive's account",
                "A track top your Shanghai team designed for China was the third hottest product in fashion earlier this year",
              ],
            },
            {
              id: "latin",
              label: "The Latin crowd",
              context: "Mexico, Puerto Rico, the diaspora",
              score: 78,
              role: "The largest new crowd",
              horizon: "short",
              drivers: [
                "Mexico's shirt sold best at the World Cup and Latin America is your fastest region",
                "Forty-two percent of Hispanic American adults planned to follow the tournament, against twenty-eight percent of all adults",
                "Twenty-eight plays read plus thirty-two, while three rivals read warmer on fewer",
                "The designer who led your lane debuted with a rival at eighty this summer",
              ],
            },
            {
              id: "terrace",
              label: "Terrace and sneakerheads",
              context: "the casual, the collector",
              score: 58,
              role: "The last chapter",
              horizon: "short",
              drivers: [
                "Originals footwear is negative this autumn by your chief executive's account",
                "Thirty-four supporters' plays read plus twenty-two, the coolest lane you play often",
                "The Football Culture collection fell from eighty-seven to zero window by window",
                "Still very strong in your chief executive's words, and still the crowd every assessment names",
              ],
            },
            {
              id: "diaspora",
              label: "Black British design",
              context: "Wales Bonner, the runway",
              score: 52,
              role: "Borrowed for now",
              horizon: "long",
              drivers: [
                "The lane's grades sit in the board's highest band",
                "Its designer leads a luxury house's menswear from January, and the collaboration continues",
                "Six plays this year, too few to carry a chapter alone",
              ],
            },
          ],
        },
        {
          kind: "matrix",
          insight:
            "No rival holds your new crowds, and each is being courted from one side. UGG and Zara read the Latin crowd warmer than you on fewer plays, On has the young woman's running shoe, and Lululemon has the studio without the warmth. The Asian fan and the women's game are the two columns you lead. The terrace is the column rivals are copying.",
          title: "Who holds which community",
          provenance: "projected",
          note: "Cell brightness is a modelled hold of each community, zero to a hundred, from each brand's plays on the record and the crowd's reads, and from this year's public moves where a brand has no record. Tap a cell for the read.",
          cols: [
            "Terrace",
            "Latin",
            "Asian fans",
            "Women's game",
            "Dance & studio",
          ],
          rows: [
            {
              label: "Adidas",
              cells: [
                {
                  v: 100,
                  note: "Your chapter. Thirty-four supporters' plays, named by every assessment, and the coolest read of any lane you play often.",
                },
                {
                  v: 100,
                  note: "Twenty-eight plays, the board's most, read plus thirty-two. Mexico's shirt sold best at the World Cup.",
                },
                {
                  v: 100,
                  note: "Eight plays read plus fifty-one, the warmest lane on the board with a real sample.",
                },
                {
                  v: 100,
                  note: "Your women's plays read plus fifty-nine, and you dress a new women's league from next season.",
                },
                {
                  v: 60,
                  note: "Nine plays read plus thirty-six, the ballet flat climbing to seventy-three.",
                },
              ],
            },
            {
              label: "Nike",
              cells: [
                {
                  v: 35,
                  note: "Sixteen supporters' plays read plus thirty-one, warmer than yours on half the plays.",
                },
                {
                  v: 45,
                  note: "Five plays read plus forty-six, with Jorge Campos on a World Cup shoe.",
                },
                {
                  v: 15,
                  note: "Five plays read plus six, the coolest on the lane.",
                },
                {
                  v: 75,
                  note: "Four plays read plus twenty-eight, the A'ja Wilson ad the lane's strongest grade, and a women-only race series of fifty thousand runners.",
                },
                {
                  v: 25,
                  note: "Two plays read plus seventeen. Sabalenka's dance film read seventy-three at best and was argued with in one window.",
                },
              ],
            },
            {
              label: "UGG",
              cells: [
                { v: 0, note: "No play on the lane." },
                {
                  v: 75,
                  note: "Six plays read plus sixty-six, and the designer who led your lane debuted here at eighty.",
                },
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
              ],
            },
            {
              label: "Zara",
              cells: [
                { v: 0, note: "No play on the lane." },
                {
                  v: 60,
                  note: "Eight plays read plus fifty-three, warmer than yours on fewer. Bad Bunny's halftime suit was Zara's.",
                },
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
                { v: 0, note: "No play on the lane." },
              ],
            },
            {
              label: "Lululemon",
              cells: [
                {
                  v: 20,
                  note: "Eight supporters' plays read plus fourteen.",
                },
                { v: 0, note: "No play on the lane." },
                { v: 10, note: "Three plays, none read yet." },
                {
                  v: 30,
                  note: "Its studio crowd is women, and its American like-for-like sales fell twelve percent this summer.",
                },
                {
                  v: 70,
                  note: "Twenty-six studio plays, the board's most, read plus ten. Presence without warmth.",
                },
              ],
            },
            {
              label: "New Balance",
              cells: [
                {
                  v: 50,
                  note: "Its retro runners sit on your terrace shelf, and its sales grew nineteen percent last year.",
                },
                { v: 0, note: "No move found on the lane." },
                { v: 15, note: "No lane-defining move this year." },
                {
                  v: 30,
                  note: "A hurdles champion among its heritage campaign's faces, an athlete more than a crowd.",
                },
                { v: 0, note: "No move found on the lane." },
              ],
            },
            {
              label: "On",
              cells: [
                { v: 0, note: "No move found on the lane." },
                { v: 0, note: "No move found on the lane." },
                {
                  v: 45,
                  note: "Its Asia-Pacific sales nearly doubled last year and grew forty-three percent this spring.",
                },
                {
                  v: 65,
                  note: "Zendaya co-designs, and upper-income teen girls name On three times as often as you for a sports shoe.",
                },
                { v: 10, note: "No dance move, a running crowd." },
              ],
            },
            {
              label: "Salomon",
              cells: [
                { v: 0, note: "No move found on the lane." },
                { v: 0, note: "No move found on the lane." },
                {
                  v: 55,
                  note: "Its core crowd in China grew from under a hundred thousand to close to ten million in five years.",
                },
                {
                  v: 30,
                  note: "Its lifestyle line is aimed at young women by its own executives, with no figures behind it.",
                },
                { v: 0, note: "No move found on the lane." },
              ],
            },
            {
              label: "Puma",
              cells: [
                {
                  v: 40,
                  note: "The Speedcat, a low shoe in your playbook's shape, made Puma's lifestyle year.",
                },
                { v: 0, note: "No move found on the lane." },
                {
                  v: 45,
                  note: "Asia-Pacific grew ten percent this autumn on the Speedcat while North America fell seventeen.",
                },
                {
                  v: 15,
                  note: "No women's league or crowd of its own this year.",
                },
                { v: 0, note: "No move found on the lane." },
              ],
            },
          ],
        },
        {
          kind: "plays",
          insight:
            "Three moves, one for each crowd that already reads you warmest. Each is built on fandom, the crowd that comes back, and each is made with the community rather than aimed at it. None of them is a new terrace shoe.",
          title: "Three moves, priced",
          provenance: "projected",
          plays: [
            {
              name: "Taekwondo Studio, the ballet sneaker and Jennie's square-toe Superstar cut for class, a free weekly studio night in Seoul, Los Angeles and London taught by the dancers on the campaign, and a members' pass for the regulars",
              itemType: "experience",
              window:
                "Spring 2027, three cities, a class every week of the season",
              strategies: [
                { code: "fandom", fit: 0.8 },
                { code: "aesthetic_innovation", fit: 0.6 },
              ],
              why: "Women who play and dance read you warmest, and the studio is where they train now. Your dance shoe went from argued with to read at seventy-three with no room around it. The board's dance band is the lowest of any community lane, so the brand that hosts the class owns it.",
              effect: {
                label: "CIQ",
                delta: 1.0,
                series: [0, 0.35, 0.65, 0.9, 1.0],
              },
              precedents: 3,
              reception:
                "your ballet flat graded 38 and climbed from −20 to 73 over eight reads, your women's plays read +59, and the board's dance band runs from 25 to 35",
              similar: [
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "Dance of Champions with Sabalenka",
                  pts: 27.7,
                },
                {
                  brand: "lululemon",
                  brandName: "Lululemon",
                  title: "SeaWheeze Half Marathon and Sunset Festival",
                  pts: 20.7,
                },
              ],
            },
            {
              name: "Originals by JENNIE, the fan chapter, the next colourway chosen by her fan clubs and sold first at fan meetings in Seoul, Tokyo and Shanghai and through the members' app, a week before any shelf",
              itemType: "collab",
              window:
                "Spring 2027, the collection's second chapter, fan meetings first",
              strategies: [
                { code: "fandom", fit: 0.9 },
                { code: "scarcity", fit: 0.4 },
              ],
              why: "The Asian fan reads you warmer than any crowd with a real sample and pays for your fastest growth. Jennie is already a co-designer and her shoe is flying. A fan club is a community that already exists, and handing it the choice turns a star collab into fandom, the strategy a community answers best.",
              effect: {
                label: "CIQ",
                delta: 0.8,
                series: [0, 0.3, 0.55, 0.75, 0.8],
              },
              precedents: 3,
              reception:
                "the Jennie teaser graded 46 and read 67, the Asian lane read +51 with a best read of 93, and a star placed on Japan's shirt read −27",
              similar: [
                {
                  brand: "uniqlo",
                  brandName: "Uniqlo",
                  title: "Uniqlo UT × G-Dragon's ZO&FRIENDS",
                  pts: 33.3,
                },
                {
                  brand: "dior",
                  brandName: "Dior",
                  title: "Dior × Jimin, the ARIRANG tour",
                  pts: 34.2,
                },
                {
                  brand: "chanel",
                  brandName: "Chanel",
                  title: "Chanel × Karina in Vogue Korea",
                  pts: 26.0,
                },
              ],
            },
            {
              name: "Hecho Con Nosotros, a Mexico and Puerto Rico line designed with local workshops paid as co-authors, a named maker on every tag, launched in the workshops' own towns before the flagship stores",
              itemType: "capsule",
              window:
                "Holiday 2027, two workshops first, a drop each season after",
              strategies: [
                { code: "identity_signal", fit: 0.7 },
                { code: "fandom", fit: 0.6 },
              ],
              why: "The Latin crowd is your biggest new community and the most contested, with three rivals reading warmer and your lead designer now at one of them. On your record the plays made with the community read best and the ones aimed at it were argued with. After the slip-on, a maker's name on the tag is the proof the crowd will look for.",
              effect: {
                label: "CIQ",
                delta: 0.6,
                series: [0, 0.2, 0.4, 0.55, 0.6],
              },
              precedents: 3,
              reception:
                "Someone Somewhere's World Cup collection graded 45 and read 80, the women artisans' kit read 60, the red ballerina −7 and the borrowed cowboys 0",
              similar: [
                {
                  brand: "ugg",
                  brandName: "UGG",
                  title: "UGG × Willy Chavarria debut capsule",
                  pts: 39.3,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "Nike × Jorge Campos World Cup",
                  pts: 31.6,
                },
                {
                  brand: "nike",
                  brandName: "Nike",
                  title: "City Jeans Puerto Rico Nike Shox community event",
                  pts: 20.0,
                },
              ],
            },
          ],
          footnote:
            "Projected effects are priced on your measured record and the public facts in the file header, and compound with your current course.",
        },
        {
          kind: "impact",
          title: "What the three moves carry",
          provenance: "projected",
          delta: 2.4,
          body: "Close to two and a half points on your published score, from 85.32 to roughly 87.7, past the leader on the board. The comparison that matters is on your own shelf. The plays a crowd made or wore its own way read far above the plays aimed at it. The qualifier is scale. The women's and Asian lanes read warmest on under ten plays each, so the read is a direction, not a verdict.",
        },
        {
          kind: "modelView",
          body: "Your community has not changed its name, and that is the finding. Every assessment this year scores it higher and describes the terrace, the casual and the sneakerhead, while the crowds paying for your growth go unnamed. The tell is the inverse on your own record. The lane you play most reads coolest, and the lanes you play least read warmest.\n\nWhat can be read at your scale is the direction, not the size. The women's lane and the Asian lane read warm on a handful of plays each, a sample one bad drop would undo. The Latin lane has the sample and the competition, and it has a memory. What the record reads with confidence is the shape. The plays a crowd made or wore its own way read far above their grade, and the plays aimed at a crowd from outside read nothing or were argued with.\n\nSo let the crowds that already read you write the next chapter with you. The studio, the fan club, the workshop. Do not retire the terrace, because it still pays, and do not announce a new identity. The record reads a brand by the company it keeps, never by what it says about itself.",
        },
      ],
    },
  ],
};
